export default {
  app: {
    whatsapp: {
      title: "WhatsApp",
      ariaLabel: "Contactar por WhatsApp",
      cta: "Contactate con nosotros",
      prefilledMessage: "Hola, quiero informacion de Clipr",
      prompt: "¿Dudas? contactanos 24/7 😉",
    },
  },
  common: {
    language: "Idioma",
    spanish: "Español",
    english: "Inglés",
    error: "Error",
    loading: "Cargando...",
    refresh: "Recargar",
    saveChanges: "Guardar cambios",
    saving: "Guardando...",
    previous: "Anterior",
    next: "Siguiente",
    page: "Página",
    of: "de",
    ago: "hace",
    in: "en",
    month: "mes",
    noActiveSession: "No hay sesión activa.",
    loginFirst: "Inicia sesión primero.",
    unexpectedError: "Error inesperado",
    today: "Hoy",
    manage: "Administrar",
    assign: "Asignar",
    save: "Guardar",
    edit: "Editar",
    back: "Regresar",
    cancel: "Cancelar",
    delete: "Eliminar",
    close: "Cerrar",
    loadMore: "Cargar más",
    stop: "Detener",
    period: "Período",
    scope: "Alcance",
    filters: "Filtros",
    admin: "Admin",
    ready: "Listo",
    filterByUsername: "Filtrar por nombre de usuario",
    filterByNameOrEmail: "Filtrar por nombre o correo",
    refreshPageHint: "Algo salió mal al cargar la página. Por favor recarga la página.",
    comingSoon: "Próximamente",
    disconnected: "Desconectado",
    enabled: "Activada",
    disabled: "Desactivada",
    yes: "Sí",
    no: "No",
    retry: "Reintentar",
    demoReadOnly: "Demo de solo lectura.",
  },
  navbar: {
    impersonationActive: "Suplantación activa",
    impersonating: "Suplantando",
    stopImpersonating: "Detener suplantación",
    tokensAvailable: "Tokens disponibles",
    tokenPriceHint: "1 token = 1 minuto",
    tokensWord: "tokens",
    menuTokens: "Tokens",
    menuProfile: "Perfil",
    menuLanguage: "Idioma",
    profileMenuAria: "Menú de cuenta",
    planLabelPrefix: "Plan: ",
    impersonationEnded: "Suplantación finalizada.",
  },
  results: {
    title: "Resultados",
    subtitle: "Jobs con clips renderizados",
    jobs: "job",
    pageShort: "pág.",
    updated: "Actualizado",
    loading: "Cargando resultados...",
    retry: "Reintentar",
    emptyTitle: "No hay clips renderizados para mostrar",
    emptyHint: "Esta pantalla muestra clips con",
    emptyHintSuffix: "no nulo, agrupados por",
    clip: "clip",
    rendered: "Renderizado",
    openHint: "Haz clic en un job para abrir su página pública con las URLs renderizadas.",
    loadError: "No se pudieron cargar las colecciones.",
    genericError: "Error al cargar los resultados. Por favor, inténtalo de nuevo.",
  },
  billing: {
    tokenBalance: "Balance de tokens",
    currentBalance: "Balance actual",
    tokenEquivalencyHint: "1 token = 1 minuto",
    tokenRenderEquivalencyHint: "1 token = 1 minuto de render",
    tokenRenderExampleHint: "Ej.: renderizar 1 stream de 1 h 30 min consume 90 tokens",
    renderHoursAvailable: "aprox. {hours} h de render",
    tokens: "tokens",
    refreshing: "Actualizando...",
    refresh: "Actualizar",
    purchaseStatus: "Estado de compra",
    reference: "Referencia",
    order: "Orden",
    subscriptionId: "Suscripción",
    subscriptionRequest: "Solicitud de suscripción",
    subscriptionStatusTitle: "Estado de suscripción",
    subscriptionStatusLabel: "Estado",
    noActiveSubscription: "Sin suscripción activa",
    noActiveSubscriptionHelp: "Aún no tienes una suscripción activa. Puedes iniciar una desde los planes de abajo.",
    currentPlan: "Plan actual",
    currentPlanDetails: "Esta es tu suscripción activa en este momento.",
    activeSubscriptionBlocksPlanPurchase: "Ya tienes una suscripción activa. Administra tu plan desde el estado de suscripción.",
    startSubscription: "Iniciar suscripción",
    subscriptionPending: "Pendiente",
    subscriptionActive: "Activa",
    subscriptionPaused: "Pausada",
    subscriptionCanceled: "Cancelada",
    subscriptionFailed: "Cobro fallido",
    subscriptionExpiresOn: "Expira el {date}",
    subscriptionBenefitsActive: "Beneficios activos",
    subscriptionBenefitsActiveUntil: "Acceso activo hasta {date}",
    subscriptionRenewsOn: "Renueva el {date}",
    paymentGraceEndsOn: "Periodo de gracia hasta {date}",
    successfulPayments: "Pagos exitosos",
    grantedTokens: "Tokens otorgados",
    renewalPaymentIssueTitle: "Hubo un problema con la renovación",
    renewalPaymentIssuePaused: "Tu suscripción está en pausa porque no pudimos completar la renovación. Actualiza tu método de pago para reactivarla y mantener tus beneficios.",
    renewalPaymentIssueFailed: "No pudimos completar la renovación. Actualiza tu método de pago o confirma que tu tarjeta tenga saldo disponible para evitar perder tus beneficios.",
    updatePaymentMethod: "Actualizar método de pago",
    updatingPaymentMethod: "Actualizando...",
    updatePaymentMethodCta: "Guardar tarjeta e intentar cobro",
    paymentMethodUpdateSummary: "Cuidemos tu suscripción",
    unableToUpdatePaymentMethod: "No se pudo actualizar tu método de pago.",
    paymentMethodUpdateConfirmed: "Tu método de pago se actualizó y el cobro fue confirmado.",
    paymentMethodUpdateFailed: "Actualizamos tu tarjeta, pero el cobro todavía no pudo confirmarse. Revisa los datos o intenta con otra tarjeta.",
    legacyPlanBannerTitle: "Tu plan ya no está disponible",
    legacyPlanBannerFallbackText: "Tu plan actual ya no está disponible para nuevas compras. Mantendrás tus beneficios actuales hasta que canceles o cambies de plan.",
    refreshSubscriptionStatus: "Reintentar verificación",
    manageSubscription: "Gestiona tu suscripción",
    cancelSubscription: "Cancelar suscripción",
    cancelSubscriptionTitle: "Cancelar suscripción",
    cancelSubscriptionPrompt: "Tu opinión nos ayuda a mejorar Clipr.",
    cancelReasonLabel: "Motivo de cancelación",
    cancelReasonPlaceholder: "Selecciona un motivo",
    cancelReasonPrice: "El precio es muy alto",
    cancelReasonUsage: "No uso Clipr lo suficiente",
    cancelReasonFeatures: "No encontré las funciones que necesito",
    cancelReasonTechnical: "Tuve problemas técnicos",
    cancelReasonOther: "Otro motivo",
    cancelMessageLabel: "Cuéntanos más",
    cancelMessagePlaceholder: "Escribe aquí tu motivo de cancelación",
    cancelReasonRequired: "Selecciona un motivo y escribe un mensaje para continuar.",
    confirmCancellation: "Confirmar cancelación",
    cancellingSubscription: "Cancelando...",
    unableToStartSubscription: "No se pudo iniciar la suscripción.",
    unableToUpgradeSubscription: "No se pudo actualizar la suscripción.",
    unableToCancelSubscription: "No se pudo cancelar la suscripción.",
    subscriptionStartPending: "Tu suscripción fue iniciada y está pendiente de confirmación.",
    subscriptionUpgradePending: "Tu cambio de plan fue solicitado y está pendiente de confirmación.",
    subscriptionUpgradeConfirmed: "Tu cambio de plan fue confirmado y tu nuevo plan ya está activo.",
    subscriptionActiveNotice: "Tu suscripción ya está activa y lista para usarse.",
    subscriptionCancelledNotice: "Suscripción cancelada correctamente.",
    checkoutSuccessTitle: "Todo listo",
    subscriptionCancelledTitle: "Suscripción cancelada",
    subscriptionCancelledSummary: "Sin más cargos.",
    subscriptionCancelledAccessUntil: "Acceso hasta {date}",
    subscriptionCancelledPlanTokens: "Plan",
    subscriptionCancelledPurchasedTokens: "Compra",
    tokensExpiring: "Tokens por vencer",
    tokensExpiringUntil: "Vigentes hasta",
    tokensExpiringUntilUnavailable: "No disponible",
    tokensPayg: "Tokens PAYG",
    expiringLots: "Lotes por vencer",
    activeLots: "Lotes activos",
    missingSubscriptionPlanCode: "No se pudo resolver el plan de suscripción.",
    billingCycle: "Ciclo de facturación",
    monthlyPlans: "Planes mensuales",
    monthly: "Mensual",
    annualPlans: "Planes anuales",
    annual: "Anual",
    changePlan: "Cambiar plan",
    upgradeSubscription: "Cambiar suscripción",
    choosePlan: "Elegir plan",
    checkout: "Checkout",
    backToPackages: "Volver a planes",
    orderSummary: "Resumen de orden",
    payment: "Detalles de pago",
    country: "País",
    searchCountry: "Buscar tu país",
    phone: "Teléfono",
    phonePlaceholder: "ej. +52 55 1234 5678",
    nameOnCard: "Nombre en la tarjeta",
    nameOnCardPlaceholder: "ej. John Smith",
    cardNumber: "Número de tarjeta",
    cardNumberPlaceholder: "ej. 4242424242424242",
    expirationDate: "Fecha de expiración",
    cvv: "CVV",
    processing: "Procesando...",
    pay: "Pagar",
    cardEncrypted: "La información de tu tarjeta está cifrada y nunca se almacena.",
    promoLabel: "¿Tienes un código promocional?",
    promoPlaceholder: "Ingresa tu código",
    promoApply: "Aplicar",
    promoChecking: "Validando...",
    promoRemove: "Quitar",
    promoApplied: "{percent}% de descuento aplicado a tu plan.",
    promoAppliedCompact: "{percent}% aplicado",
    promoInvalid: "El código promocional no es válido.",
    proBenefitsTitle: "Beneficios desbloqueados",
    confirmed: "Confirmada",
    failed: "Fallida",
    pendingConfirmation: "Confirmación pendiente",
    paymentConfirmed: "Tu pago fue confirmado y tus tokens ya están disponibles.",
    purchaseFailed: "No se pudo completar tu pago.",
    billedMonthly: "Facturado cada mes",
    billedYearly: "Facturado cada año",
    month: "mes",
    year: "año",
    countryRequired: "El país es obligatorio.",
    phoneRequired: "El teléfono es obligatorio.",
    phoneFormatInvalid: "Usa el formato internacional como +525512345678.",
    nameOnCardRequired: "El nombre en la tarjeta es obligatorio.",
    cardNumber16: "El número debe tener 15 dígitos para Amex o 16 para Visa y Mastercard.",
    expiryMonthInvalid: "El mes de expiración debe ser 01-12.",
    expiryYearInvalid: "El año de expiración no es válido o está vencido.",
    cvv3: "El CVV debe tener 4 dígitos para Amex o 3 para Visa y Mastercard.",
    subscriptionUpgradeFailed: "No se pudo confirmar tu cambio de plan.",
    subscriptionStartFailed: "No se pudo confirmar tu suscripción.",
    requestErrorTitle: "No pudimos completar tu solicitud",
    recurringCheckoutPending: "Tu plan seleccionado está listo, pero la integración de checkout recurrente aún está pendiente.",
    selectPlanToContinue: "Selecciona un plan para continuar.",
    plansKicker: "Planes",
    plansTitle: "Elige tu plan",
    plansDescription: "Empieza gratis o desbloquea todo con Unlimited.",
    freePlanName: "Free",
    freePlanCaption: "Sin costo, para siempre",
    freeFeatureTokens: "240 tokens al mes",
    freeFeatureFirstStream: "Primer stream gratis de hasta 4 horas",
    freeFeatureWatermark: "Clips con marca de agua",
    freeFeatureNoSocials: "Sin conexión de redes sociales",
    freeFeatureNoSchedule: "Sin programación de publicaciones",
    freeFeatureNoAi: "Sin análisis con IA",
    freeFeatureNoEditor: "Sin editor de clips",
    unlimitedPlanName: "Unlimited",
    unlimitedPlanBadge: "Todo incluido",
    unlimitedFeatureTokens: "720 tokens al DIA",
    unlimitedFeatureNoWatermark: "Sin marca de agua",
    unlimitedFeatureSocials: "Conecta tus redes sociales",
    unlimitedFeatureSchedule: "Programa tus publicaciones",
    unlimitedFeatureAi: "Análisis de streams con IA",
    unlimitedFeatureEditor: "Editor de clips PRO",
    unlimitedFeatureAnalytics: "Analytics de posts a 1 y 7 días",
    comingSoon: "Próximamente",
    annualEquivalentPerMonth: "Equivale a ${amount} USD/mes",
    annualSavingsVsMonthly: "Ahorra {percent}% vs el plan mensual",
    paymentGraceWarning: "Tu suscripción expira pronto porque el último cobro no se completó. Actualiza tu método de pago o asegúrate de tener saldo disponible antes del {date} para conservar tus beneficios.",
  },
  tryClips: {
    backAria: "Regresar",
    backToSocialNetworksAria: "Regresar a redes",
    leaveConfirm: "¿Seguro que quieres salir? Perderás el progreso de este paso.",
    formatTitle: "¿Qué tipo de contenido es?",
    formatHelper: "Elige el tipo que mejor describe tu contenido.",
    validatingBadge: "Validando…",
    sourceDownload: {
      eyebrow: "Descargando de {platform}",
      subtitle: "Trayendo tu video a Clipr…",
      genericTitle: "Tu video",
      sourceFallback: "Origen",
      downloadSize: "≈ {size} por descargar",
    },
    downloadStartingTitle: "Iniciando la descarga",
    emailTitle: "Verifica tu correo",
    emailSubtitle: "Ingresa tu correo y te enviaremos un código rápido para crear tu cuenta.",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "tu-correo@email.com",
    processing: "Procesando...",
    sendCode: "Quiero mis clips",
    legal: {
      acceptPrivacyPrefix: "Acepto el ",
      privacyNoticeLink: "Aviso de Privacidad",
      acceptTermsPrefix: "Acepto los ",
      termsAndConditionsLink: "Términos y Condiciones",
    },
    tryUsedTitle: "Esta prueba ya no está disponible",
    tryUsedBody: "Este correo ya utilizó su prueba gratuita.",
    loginCta: "Iniciar sesión",
    helpCta: "Ayuda",
    helpWhatsappMessage: "Hola! Necesito ayuda en https://app.clipr.tv/create-clips",
    socialThanks: "¡Gracias! Tus clips están en camino",
    socialThanksSubtitle:
      "Esto tarda unos minutos. Mantén esta pestaña abierta mientras renderizamos tus mejores momentos — aparecerán aquí automáticamente en cuanto estén listos.",
    renderingTipsEyebrow: "¿Sabías que...?",
    renderingTips: [
      "Bajando tu video a toda velocidad…",
      "Transcribiendo con IA en GPU…",
      "Buscando los momentos con más enganche…",
      "Renderizando en vertical, listo para publicar…",
      "Casi listo — esto a otros les toma minutos.",
    ],
    greetingHi: "Hola, {name} 👋",
    greetingSub: "Vamos a encontrar tus mejores momentos.",
    preferredNameQuestion: "Tu Nombre",
    preferredNameSub: "¿Cómo te llamamos?",
    preferredNamePlaceholder: "ej. Bob",
    socialNetworksQuestion: "¿Dónde publicas tu contenido?",
    socialNetworksSub: "Cuéntanos tus plataformas para renderizar tus clips a tu estilo.",
    socialUrlsQuestion: "Comparte tus perfiles para que aprendamos tu estilo",
    socialUrlAria: "URL de {network}",
    socialPlaceholders: {
      instagram: "https://www.instagram.com/tu_usuario/",
      facebook: "https://www.facebook.com/tu.pagina/",
      x: "https://x.com/tu_usuario",
      tiktok: "https://www.tiktok.com/@tu_usuario",
      youtube: "https://www.youtube.com/@tu_canal",
    },
    socialEmptyCopy: "Selecciona al menos una red social para completar este paso.",
    continue: "Continuar",
    saving: "Guardando...",
    submitAnswers: "Ver mis clips",
    processingVideoTitle: "Procesando tu video...",
    processingFailedSubtitle:
      "No pudimos completar el procesamiento. Revisa la URL e inténtalo de nuevo.",
    extraClipsLabel: "clips más",
    extraClipsHint: "Desbloquea para verlos",
    extraClipsScoreHintOne: "1 con buen score",
    extraClipsScoreHintMany: "{count} con buen score",
    viewPlans: "Ver planes",
    resultsEyebrow: "Clips listos",
    resultsTitle: "Tus clips están listos",
    resultsTitleNamed: "Tus clips están listos, {name}",
    resultsSubtitle: "Desbloquea todos tus clips.",
    results: {
      speedFlex: "Tu video de {duration} → estos clips, en segundos",
    },
    resultExpiry: {
      topTitle: "Tus clips están disponibles por tiempo limitado.",
      topSubtitle: "Quedan {time}",
      bottomTitle: "El reloj corre.",
      bottomSubtitle: "Descárgalos antes de que expire tu acceso: {time}",
    },
    unlockAllCta: "Desbloquear todos mis clips",
    unlockAllNote: "Sin marca de agua · completos · listos para publicar",
    accountExistsTitle: "Inicia sesión y elige un plan",
    accountExistsBody:
      "Este correo ya tiene una cuenta. Inicia sesión y elige un plan para seguir renderizando.",
    alreadySubscribedTitle: "Ya tienes Clipr activo",
    alreadySubscribedBody:
      "Tu cuenta ya cuenta con una suscripción activa. Te llevamos a la app para que sigas creando clips.",
    alreadySubscribedCta: "Ir a la app",
    accountCreatedBadge: "Pago confirmado",
    accountCreatedTitle: "Gracias por tu pago",
    accountCreatedBody: "Tu cuenta Premium ya está lista. Guarda tu contraseña antes de continuar.",
    accountCreatedPlanLabel: "Plan adquirido",
    accountCreatedPasswordLabel: "Tu contraseña de acceso",
    accountCreatedPasswordCopy: "Copiar",
    accountCreatedPasswordCopied: "Copiada",
    accountCreatedPasswordHint: "Guárdala en un lugar seguro. La necesitarás para iniciar sesión.",
    accountCreatedCta: "Ir a Clipr Premium",
    accountCreatedFreeBadge: "Cuenta creada",
    accountCreatedFreeTitle: "Tu plan gratis está listo",
    accountCreatedFreeCta: "Ir a Clipr",
    subscriptionPendingTitle: "Confirmando tu suscripción",
    subscriptionPendingBody:
      "Estamos validando el pago y habilitando tus tokens. Esto puede tardar unos segundos.",
    subscriptionPendingRefreshCta: "Actualizar estado",
    orSeparator: " o ",
    contentTypes: {
      gameplay: {
        label: "Pantalla dividida",
        description: "Tu cámara arriba, tu contenido abajo.",
      },
      podcast: {
        label: "Podcast",
        description: "Varias personas en pantalla.",
      },
      irl: {
        label: "Video completo",
        description: "Se ve todo, con fondo difuminado.",
      },
      justChatting: {
        label: "Estándar",
        description: "Una sola toma, centrada.",
      },
    },
    loader: {
      rendering: "Renderizando",
      downloading: "Descargando...",
      speedEyebrow: "Procesando a toda velocidad",
      hintDownloading: "",
      hintRendering: "",
      eta: {
        minUnit: "min",
        minutesRemaining: "min restantes",
        oneMinuteAria: "1 min",
        minutesRemainingAria: "{minutes} min restantes",
      },
    },
    downloadAnimation: {
      platformDetected: "Plataforma detectada",
      failed: "Proceso fallido",
      validating: "Validando",
      preparing: "Preparando",
      confirmingUrl: "Confirmando URL",
    },
    verification: {
      title: "Revisa tu correo",
      subtitle: "Ingresa el código de 6 dígitos que acabamos de enviar a {email}.",
      codeLabel: "Código de verificación",
      codeGridAria: "Código de verificación",
      verifying: "Verificando...",
      resendCode: "Reenviar código",
      resending: "Reenviando...",
      resendCountdown: "Reenviar código en {seconds}s",
    },
    clipCard: {
      free: "Gratis",
      scoreTitle: "Score del clip",
      playClipAria: "Reproducir clip",
      unlockClipAria: "Desbloquear clip",
      unlockFull: "Desbloquea para verlo completo",
      ready: "Ya está listo",
    },
    urlForm: {
      heroTitle: "Convierte tu stream en clips virales",
      heroSubtitle:
        'Pega el enlace de tu video y recibe clips listos para publicar <span class="try-url-hero-subtitle-accent">gratis</span>!',
      heroStep1: "Pega tu enlace",
      heroStep2: "Elige el formato",
      heroStep3: "Recibe tus clips",
      urlLabel: "URL del video",
      autodetected: "Autodetectado",
      unknownPlatform: "Desconocida",
      validatingInfo: "Validando información",
      drivePermissionsTitle: "Permisos públicos requeridos",
      drivePermissionsBody:
        'Asegúrate de que el archivo en Google Drive sea público: "Cualquiera con el enlace" y con descarga permitida.',
      facebookReelHorizontalTitle: "Formato horizontal requerido",
      facebookReelHorizontalBody: "Si usas Facebook Reels, asegúrate de que tu Reel esté en formato horizontal (16:9).",
      errors: {
        unrecognizedUrlTitle: "URL no reconocida",
        unrecognizedUrlMessage:
          "URL no reconocida. Solo se admiten Twitch, YouTube, Facebook, Kick y Google Drive público.",
        invalidTwitchTitle: "Formato de Twitch inválido",
        invalidYoutubeTitle: "Formato de YouTube inválido",
        invalidFacebookTitle: "Formato de Facebook inválido",
        invalidKickTitle: "Formato de Kick inválido",
        invalidGoogleDriveTitle: "Formato de Google Drive inválido",
        invalidUrlTitle: "Formato de URL inválido",
        twitchFormat: "Solo se admiten URLs de VOD. Formato: https://www.twitch.tv/videos/<dígitos>",
        youtubeFormat: "Formato de URL de YouTube inválido. Usa /watch?v=..., /live/... o youtu.be/...",
        facebookFormat: "Formato de URL de Facebook inválido. Usa .../videos/<id>",
        kickFormat: "Formato de URL de Kick inválido. Usa https://kick.com/<canal>/videos/<id>",
        googleDriveFormat:
          "Formato de URL de Google Drive inválido. Usa un enlace público de archivo: /file/d/<id>/... o /open?id=<id>.",
        invalidUrlMessage: "Formato de URL inválido.",
      },
    },
    paywall: {
      noPlans: "No hay planes disponibles en este momento.",
      availablePlans: "Planes disponibles",
      heroEyebrow: "Acabas de verlo",
      heroSpeedTitle: "Tu video de {duration} → clips listos",
      heroSpeedSub:
        "Lo descargamos y editamos en segundos. Otros tardan minutos solo en bajarlo.",
      yourClipsTitle: "Tus {count} clips ya están listos",
      yourClipsSubtitle: "{unlocked} desbloqueado · {count} esperándote",
      yourClipsSubtitleAll: "{unlocked} listos para ti",
      unlockHeadline: "Desbloquea tus otros {count} clips",
      unlockHeadlineAll: "Desbloquea todos tus clips",
      valueUnlimited: "Hasta 12 horas de video al día — de los mejores del mercado",
      valueKeepClips: "Conserva los clips que ya creamos para ti",
      valueCancel: "Cancela cuando quieras, sin enredos",
      expiryCountdown: "Tus clips se borran en {time}",
      socialProofTitle: "Clips reales hechos con Clipr",
      popularBadge: "Más popular",
      bestValueBadge: "Mejor valor",
      startFreePlanBadge: "Gratis",
      startFreePlanName: "Start Free",
      startFreePlanDescription: "Crea tu cuenta gratis y empieza desde Clipr.",
      startFreePlanCaption: "Sin tarjeta, sin costo",
      startFreePlanTrial: "Plan gratis para empezar",
      offerTokensFree: "240 tokens al mes",
      offerTokensUnlimited: "720 tokens al día",
      tokenEquivalencyHint: "1 token = 1 minuto de renderizado",
      freePlanProDisclaimer: "Sin funciones PREMIUM",
      freePlanWatermarkDisclaimer: "Clips con marca de agua",
      startFreeBenefitAccountTitle: "Cuenta lista al instante",
      startFreeBenefitAccountBody: "Te llevamos directo a Clipr con tu contraseña.",
      startFreeBenefitUpgradeTitle: "Puedes subir a Unlimited después",
      startFreeBenefitUpgradeBody: "Desbloquea clips ilimitados y funciones PRO cuando quieras.",
      freePriceLabel: "Gratis",
      offerDiscount: "-{percent}%",
      playClipAria: "Reproducir clip",
      lockedClipsOverflowAria: "{count} clips más esperándote — desbloquéalos",
      unlimitedClips: "Clips ilimitados",
      billedMonthly: "Facturación mensual",
      billedAnnually: "${amount} {currency} facturados una vez al año",
      perMonthShort: "/mes",
      choosePlan: "Elegir plan",
      orderSummary: "Resumen de orden",
      proBenefitsTitle: "Lo que desbloqueas con Premium",
      demoClipsEyebrow: "Clips reales",
      demoClipsTitle: "Mira resultados listos para publicar",
      demoClipsViews: "{count} vistas",
      demoClipsPlayAria: "Reproducir clip de {platform} con {views} vistas",
      demoClipsPauseAria: "Pausar clip de {platform} con {views} vistas",
      paymentDetails: "Detalles de pago",
      country: "País",
      searchCountry: "Buscar país...",
      clearCountryAria: "Limpiar país seleccionado",
      phone: "Teléfono (opcional)",
      nameOnCard: "Nombre en tarjeta",
      nameOnCardPlaceholder: "Nombre completo",
      cardNumber: "Número de tarjeta",
      cardNumberPlaceholder: "ej. 4242424242424242",
      expiration: "Expiración",
      cvc: "CVC",
      processingPayment: "Procesando pago...",
      payAndUnlock: "Pagar y desbloquear",
      choosePlanTitle: "Elige tu plan",
      choosePlanSub: "Acceso inmediato a todos tus clips — cancela cuando quieras",
      checkoutDueToday: "Se cobra hoy: ${amount} {currency}",
      checkoutRenewsMonthly: "Se renueva a ${amount} {currency}/mes. Cancela cuando quieras.",
      checkoutRenewsAnnually: "Se renueva a ${amount} {currency}/año — equivale a ${monthly}/mes. Cancela cuando quieras.",
      checkoutKeepClips: "Conserva los clips que ya creamos para ti",
      cardEncrypted: "La información de tu tarjeta está cifrada y nunca se almacena.",
      promoLabel: "¿Tienes un código promocional?",
      promoPlaceholder: "Ingresa tu código",
      promoApply: "Aplicar",
      promoChecking: "Validando...",
      promoRemove: "Quitar",
      promoApplied: "{percent}% de descuento aplicado a tu plan.",
      promoAppliedCompact: "{percent}% aplicado",
      promoInvalid: "El código promocional no es válido.",
      promoSessionError: "Sesión inválida para validar el código.",
      benefits: {
        perfectClipTitle: "Editor de video pro",
        perfectClipBody: "Reencuadra, recorta y ajusta cada clip.",
        brandEndTitle: "Conecta tus redes",
        brandEndBody: "Publica directo en TikTok, Instagram y YouTube.",
        noWatermarkTitle: "Sin marca de agua",
        noWatermarkBody: "Tus clips salen limpios, listos para publicar.",
        publishTitle: "Programa tus publicaciones",
        publishBody: "Agenda y postea en automático.",
        speedTitle: "Velocidad sin igual",
        speedBody: "Procesa videos de horas en segundos.",
      },
      errors: {
        countryRequired: "El país es obligatorio.",
        phoneRequired: "El teléfono es obligatorio.",
        phoneFormat: "Usa el formato +525512345678.",
        nameOnCardRequired: "El nombre en la tarjeta es obligatorio.",
        cardNumberLength: "El número debe tener 15 dígitos para Amex o 16 para Visa y Mastercard.",
        testCardLocalOnly: "Las tarjetas de prueba solo están permitidas en desarrollo local.",
        expiryMonth: "El mes de expiración debe ser 01-12.",
        expiryYear: "El año de expiración no es válido o está vencido.",
        cvcLength: "El CVC debe tener {count} dígitos.",
      },
    },
    errors: {
      selectSocialNetwork: "Selecciona al menos una red social.",
      preferredNameRequired: "Cuéntanos cómo prefieres que te llamemos.",
      socialProfileRequired: "Ingresa tu URL de {network}.",
      socialUrlNoSpaces: "La URL no debe contener espacios.",
      socialUrlInvalid: "Ingresa una URL válida (incluye https://).",
      socialUrlHostRequired: "La URL debe pertenecer a {hosts}.",
      socialSessionMissing: "No hay una sesión activa para guardar respuestas.",
      correctSocialUrls: "Corrige las URLs antes de continuar.",
      socialSaveError: "No se pudieron guardar tus respuestas.",
      metadataServiceConfig:
        "El backend no tiene configurado el servicio de metadata para YouTube/Kick. Agrega CLIPR_YOUTUBE_METADATA_API_KEY al .env del backend y reinícialo.",
      metadataValidation: "No se pudo validar la URL del stream.",
      durationLimit: "Este stream supera el límite gratuito de 4 horas. Pega un stream más corto para continuar.",
      durationRequired: "No pudimos validar la duración del stream. Usa una URL con duración disponible.",
      verticalNotSupported: "Este video está en formato vertical. Solo admitimos videos horizontales (16:9).",
      selectFormat: "Selecciona un formato antes de continuar.",
      emailRequired: "Ingresa un correo para continuar.",
      emailInvalid: "Ese correo no parece válido. Revísalo e inténtalo de nuevo.",
      privacyNoticeRequired: "Debes aceptar el Aviso de Privacidad para continuar.",
      termsAndConditionsRequired: "Debes aceptar los Términos y Condiciones para continuar.",
      tryStart: "No se pudo iniciar la prueba.",
      networkError: "No pudimos conectarnos al servidor. Verifica tu conexión e inténtalo de nuevo.",
      resendCode: "No se pudo reenviar el código.",
      invalidVerificationResponse: "Respuesta inválida del servidor para verificación.",
      invalidTrackingResponse: "Respuesta inválida del servidor para seguimiento del try.",
      invalidVerificationSession: "Sesión de verificación inválida. Inténtalo de nuevo.",
      verifyCode: "No se pudo verificar el código.",
      statusLoad: "No se pudo cargar el estado de la prueba.",
      subscriptionStatusLoad:
        "No pudimos validar el estado de tu suscripción. Reintentaremos automáticamente.",
      subscriptionNotConfirmed:
        "No se pudo confirmar el pago de la suscripción. Inténtalo de nuevo.",
      unlockSession: "No existe una sesión válida para desbloquear.",
      checkout: "No se pudo completar el pago.",
      generatedPasswordMissing: "El pago se confirmó, pero el servidor no devolvió la contraseña. Reinicia el backend y vuelve a intentarlo.",
    },
  },
  onboarding: {
    stepOf: "Paso {n} de {total}",
    back: "Atrás",
    next: "Continuar",
    finish: "Finalizar",
    skip: "Omitir",
    title: "Completa tu cuenta",
    subtitle: "Antes de continuar, agrega tu teléfono en formato internacional.",
    phoneLabel: "Número de teléfono",
    phonePlaceholder: "+525512345678",
    phoneHint: "Usa el formato internacional completo, por ejemplo +525512345678.",
    phonePromoHint: "Agrega tu número para completar tu perfil.",
    ageRangeLabel: "¿Cuál es tu rango de edad?",
    editingProcessLabel: "¿Cómo describes tu proceso actual de edición?",
    socialFrequencyLabel: "¿Cuál es tu frecuencia actual en redes?",
    primaryGoalLabel: "¿Qué quieres más?",
    ageRangeOptions: {
      "18_24": "18–24",
      "25_34": "25–34",
      "35_44": "35–44",
      "45_54": "45–54",
      "55_64": "55–64",
      "65_plus": "65+",
    },
    editingProcessOptions: {
      self_editing: "Lo hago yo mismo.",
      editor_or_freelancer: "Tengo un editor o freelancer.",
      internal_team: "Tengo un equipo interno.",
      not_editing_videos: "No estoy editando videos actualmente.",
    },
    socialFrequencyOptions: {
      post_daily: "Publico diario.",
      post_once_or_twice_weekly: "Publico 1 o 2 veces por semana.",
      post_randomly: "Publico de forma aleatoria cuando tengo tiempo.",
      have_material_but_rarely_post: "Tengo el material grabado pero casi nunca llego a publicarlo.",
    },
    primaryGoalOptions: {
      find_viral_moments: "Encontrar momentos virales",
      save_editing_time: "Ahorrar tiempo de edición",
      post_more_consistently: "Publicar con más consistencia",
      auto_publish_to_socials: "Auto-publicar en redes",
    },
    submitting: "Guardando...",
  },
  makeClips: {
    sourceModeLabel: "Origen del video",
    uploadMp4Toggle: "Subir MP4",
    uploadMp4Label: "Archivo MP4",
    uploadMp4DropTitle: "Arrastra tu MP4 o selecciónalo",
    uploadMp4DropHint: "Haz clic para buscar el archivo",
    uploadMp4HeroSubtitle:
      'Sube tu MP4 y recibe clips listos para publicar <span class="try-url-hero-subtitle-accent">en minutos</span>!',
    uploadMp4Requirements: "MP4 horizontal, máximo 1080p, 12 h y 100 GiB.",
    uploadPlanRequired: "La subida de MP4 requiere el plan Unlimited.",
    uploadAlreadyActive: "Ya tienes una subida MP4 activa.",
    uploadInvalidMp4: "Selecciona un archivo MP4 válido.",
    uploadVerticalNotSupported: "El video es vertical. Solo se admiten MP4 horizontales.",
    uploadResolutionExceeded: "La resolución supera 1080p.",
    uploadDurationExceeded: "El video supera el máximo de 12 horas.",
    uploadSizeExceeded: "El archivo supera el máximo de 100 GiB.",
    uploadIncomplete: "La subida está incompleta. Inténtalo de nuevo.",
    uploadWaiting: "La subida sigue esperando disponibilidad.",
    uploadFailed: "No se pudo subir el MP4.",
    uploadReserving: "Reservando subida...",
    uploadUploading: "Subiendo MP4...",
    uploadCompleting: "Finalizando subida...",
    uploadComplete: "Subida completada.",
    uploadQueuePosition: "Posición en cola: {position}",
    enableSubtitles: "Agregar subtítulos",
    enableSubtitlesDescription: "Genera subtítulos automáticos en tus clips.",
    subtitlesStatusOn: "Activados",
    subtitlesStatusOff: "Desactivados",
    flowStep2Chip: "Paso 2 de 3",
    flowStep3Chip: "Paso 3 de 3",
    flowConfigureTitle: "Elige el tipo de video",
    flowConfigureSubtitle: "Define el layout de tus clips.",
    flowConfirmTitle: "Revisa y confirma",
    flowConfirmSubtitle: "Confirma el costo y envía a la cola.",
    flowBack: "Volver",
    flowContinue: "Continuar",
    flowChange: "Cambiar",
    flowVideoDetected: "Video detectado",
    flowDurationHint: "Duración: {duration}",
    flowTrimHint: "Déjalo vacío para procesar el VOD completo, o marca en la línea de tiempo solo los momentos que quieres.",
    flowNoDurationTitle: "No pudimos obtener la duración del video",
    flowNoDurationBody: "Define tus segmentos manualmente con los campos de tiempo para calcular el costo.",
    flowNeedSegmentsForCost: "Añade al menos un segmento para poder calcular el costo de este video.",
    flowSelectTypeHint: "Selecciona un tipo para continuar.",
    flowQueuedSuccess: "¡Tu video está en cola! Revisa tus colecciones para ver el progreso.",
    flowQueuedSuccessAdmin: "Video encolado. Puedes agregar otro de inmediato.",
    flowValidationErrorTitle: "No pudimos validar tu video",
    flowAutoValidateHint: "Validaremos tu video automáticamente. Presiona Enter si no avanza.",
    flowSubmitError: "No pudimos encolar tu video. Inténtalo de nuevo.",
    flowNoSpaceForSegment: "Ya no hay espacio disponible al final del video para otro segmento.",
    flowValidationTimeout: "La validación está tardando demasiado. Inténtalo de nuevo.",
    flowReassignFailed: "El video se encoló, pero no se pudo asignar al usuario seleccionado.",
    timelineTrimLabel: "Línea de recorte",
    timelineEmptyHint: "Haz clic en la línea de tiempo para añadir un segmento",
    timelineHelp: "Arrastra los bordes para ajustar inicio y fin, arrastra el bloque para moverlo o haz clic en un espacio libre para añadir otro segmento.",
    addAnotherClip: "Agregar otro clip",
    urlHeroSubtitle:
      'Pega el enlace de tu video y recibe clips listos para publicar <span class="try-url-hero-subtitle-accent">en minutos</span>!',
    firstFreeStreamBannerChip: "Oferta de bienvenida",
    firstFreeStreamBannerTitle: "Tu primer stream gratis de hasta 4 horas",
    firstFreeStreamBannerSubtitle:
      "Tienes 24 horas desde la creacion de tu cuenta para aprovecharlo.",
    firstFreeStreamCountdownLabel: "Aprovecha la oferta, tiempo restante",
    firstFreeStreamBannerCta: "Crear mi primer stream",
    firstFreeStreamCost: "Gratis",
    firstFreeStreamCostHint: "Incluido en tu oferta de bienvenida.",
    firstFreeStreamDurationLimit: "Tu primer stream gratis admite hasta 4 horas. Recorta el VOD para continuar.",
    unlimitedDailyStreamLimit: "El límite diario son 12 horas de video. Puedes recortar el stream para procesarlo. Disculpa las molestias.",
    enterVideoUrl: "Ingresa URL del video",
    autodetected: "Autodetectado",
    supportedFormats: "Formatos soportados: Twitch, YouTube, Facebook, Kick, Google Drive (público).",
    videoTypeLabel: "Tipo de video",
    videoTypeAuto: "Auto",
    videoTypeIrl: "Video completo",
    videoTypeGameplay: "Pantalla dividida",
    videoTypeJustChatting: "Estándar",
    videoTypeStream: "Stream",
    videoTypePodcast: "Podcast",
    videoTypeModalHelper: "Elige el formato antes de crear el VOD para que el render use el layout correcto desde el inicio.",
    videoTypeGameplayDescription: "Tu cámara arriba, tu contenido abajo.",
    videoTypeJustChattingDescription: "Una sola toma, centrada.",
    videoTypeIrlDescription: "Se ve todo, con fondo difuminado.",
    videoTypePodcastDescription: "Varias personas en pantalla.",
    videoTypeCenterDescription: "Vertical centrado.",
    selectVideoTypeBeforeCreate: "Selecciona un tipo de video antes de crear clips.",
    trimVideoTitle: "Ajusta el rango del video",
    trimVideoHelper: "Ajusta el rango en la línea de tiempo.",
    videoGeneralContextHelper: "Añade detalles que ayuden a la IA a entender la escena",
    defineSegments: "Definir segmentos",
    optionalSegments: "Segmentos opcionales",
    optionalSegmentsHint: "Déjalo vacío para procesar el VOD completo. Añade segmentos solo si quieres momentos concretos.",
    optionalSegmentsPrompt: "¿Solo quieres momentos concretos?",
    showOptionalSegments: "Añadir segmentos opcionales",
    hideOptionalSegments: "Ocultar",
    addSegment: "Añadir segmento",
    fullVodDefault: "VOD completo",
    fullVodHint: "Procesaremos todo el video si no defines segmentos.",
    segmentsSequenceHint: "Los segmentos se procesan en orden y no pueden superponerse.",
    totalCutTime: "Tiempo total cortado",
    processingRequest: "Procesando tu solicitud...",
    noEnoughTokens: "No tienes tokens suficientes para este stream",
    enterValidUrlFirst: "Introduce primero una URL de video válida",
    fixSegmentsBeforeSubmit: "Corrige los tiempos de los segmentos antes de enviar",
    selectAssigneeFirst: "Debes seleccionar un usuario en Asignar antes de crear clips",
    startCreateClips: "Comenzar a crear clips de tu video",
    reviewBeforeCreate: "Revisa antes de crear",
    reviewBeforeCreateHint: "Confirma el costo, la duración y tus segmentos antes de enviarlo a la cola.",
    reviewClips: "Revisar clips",
    getClips: "Obtener clips",
    reviewClipsTitle: "Revisa tu video y tus segmentos antes de crear clips.",
    inQueue: "En cola...",
    queueingClips: "Encolando...",
    createClips: "Crear clips",
    insufficientTokens: "No tienes tokens suficientes",
    need: "necesitas",
    have: "tienes",
    buyTokens: "Comprar tokens",
    autoProcessHint: "Tus clips se procesarán automáticamente. Revisa tus colecciones para ver el progreso.",
    clipLabel: "Clip",
    segmentLabel: "Segmento",
    segmentNamePlaceholder: "Nombre opcional",
    start: "INICIO",
    end: "FIN",
    confirmCreateTitle: "Confirmar creación de clips",
    confirmCreateSubtitle: "Revisa la información del video antes de enviar a la cola",
    confirmAndCreate: "Crear clips",
    loadingVodInfo: "Obteniendo información de los VODs...",
    loadingVideoInfo: "Obteniendo información del video...",
    assignedUser: "Usuario asignado",
    unassignedCurrentUser: "Sin reasignar (se crea para tu usuario actual)",
    tokensSummary: "Resumen de tokens",
    changeVideoType: "Cambiar",
    dailyRenewal: "Renovación diaria",
    tokenMinuteRate: "1 token = 1 minuto",
    unlimitedTokensDailyHint: "Tus tokens se renuevan diariamente.",
    tokenSingular: "token",
    tokenPlural: "tokens",
    vodsToProcess: "VODs a procesar",
    totalTime: "Tiempo total",
    processingTime: "Tiempo a procesar",
    processingDurationHint: "Se procesará {duration}",
    totalEstimatedCost: "Costo estimado total",
    estimatedCost: "Costo estimado",
    tokensLabel: "En tokens",
    yourBalance: "Tu saldo",
    remainingAfter: "Quedarían",
    costCalculatedWithSegments: "Costo calculado con tus segmentos seleccionados.",
    costCalculatedWithFullVod: "Costo calculado con la duración total del VOD.",
    notEnoughTokensForVods: "No tienes tokens suficientes para procesar estos VODs.",
    notEnoughTokensForVod: "No tienes tokens suficientes para procesar este VOD.",
    insufficientTokensWithClipSuggestion:
      "No tienes tokens suficientes. Puedes adquirir más tokens o recortar un segmento de tu stream usando la herramienta de recorte debajo de \"Enter video url\".",
    selectedSegments: "Segmentos seleccionados",
    noSegmentsFullVod: "No hay segmentos definidos. Se procesará el VOD completo.",
    videoGeneralContext: "Contexto general del video",
    enableVideoGeneralContext: "Activar contexto",
    videoGeneralContextPlaceholder: "Agrega contexto general para este video (opcional)",
    assignCreateTitle: "Asignar creación de clips",
    assignCreateSubtitle: "Selecciona el usuario al que se asignará este VOD al crearlo.",
    assignClipCreationUser: "Usuario para creación de clips",
    noAssignableUsers: "No hay usuarios disponibles con acceso de Twitch.",
    close: "Cerrar",
    scheduleSubscriptionPromptTitleNoSubscription: "Pasa a Unlimited",
    scheduleSubscriptionPromptBodyNoSubscription:
      "Con Unlimited obtienes 720 tokens al día, puedes editar tus clips, personalizar la pantalla final y eliminar la marca de agua.",
    scheduleSubscriptionPromptTitleWithSubscription: "Tu suscripción Unlimited",
    scheduleSubscriptionPromptBodyWithSubscription:
      "Tu cuenta ya tiene una suscripción activa con tokens diarios y clips sin marca de agua.",
    scheduleSubscriptionPromptSubscribeCta: "Suscribirme",
    scheduleSubscriptionPromptContinueCta: "Continuar de todos modos",
    scheduleSubscriptionPromptImageAlt: "Vista previa del watermark en un clip generado",
    scheduleSubscriptionPromptImageCaption:
      "Con Unlimited puedes editar tus clips, quitar la marca de agua y cerrar cada video con una pantalla final personalizada.",
    scheduleSubscriptionPromptBenefitTokens: "720 tokens al día para publicar clips sin fricción.",
    scheduleSubscriptionPromptBenefitEditor:
      "Edita tus clips: ajusta el inicio y final, cambia el tipo de video y vuelve a renderizar sin perder el flujo.",
    scheduleSubscriptionPromptBenefitEndCard:
      "Agrega una pantalla final con tu @ y una imagen personalizada para que cada clip cierre con tu marca.",
    scheduleSubscriptionPromptBenefitWatermark: "Elimina la marca de agua y mejora la percepción de tu marca.",
    scheduleSubscriptionPromptBenefitScale: "Conecta tus redes sociales y programa tus publicaciones para acelerar tu crecimiento.",
    scheduleSubscriptionPromptBenefitCustomLogo:
      "Añade tu logo en la pantalla final: cada clip cierra con tu marca, se ve más profesional y refuerza que el contenido es tuyo.",
    scheduleSubscriptionPromptProof:
      "Activa tu suscripción en menos de un minuto y sigue programando sin salir del flujo.",
    streamSegments: "Segmentos del stream",
    connectedAccounts: "Redes",
    authRequired: "Debes iniciar sesión.",
    resolveUserIdError: "No se pudo resolver el user_id del usuario.",
    assigneeUserIdNotFound: "No se encontró el user_id del usuario seleccionado.",
    reassignJobError: "No se pudo reasignar el job.",
    assignUserBeforeCreate: "Debes asignar un usuario antes de crear clips.",
    bulkAddAtLeastOneValidUrl: "Agrega al menos una URL válida para crear clips.",
    enterValidUrl: "Debes ingresar una URL válida.",
    urlOnlyVodsTwitch: "Solo se admiten URLs de VOD. Formato: https://www.twitch.tv/videos/<dígitos>",
    invalidYoutubeUrlFormat: "Formato de URL de YouTube inválido. Usa /watch?v=..., /live/... o youtu.be/...",
    invalidFacebookUrlFormat: "Formato de URL de Facebook inválido. Usa .../videos/<id>",
    invalidKickUrlFormat: "Formato de URL de Kick inválido. Usa https://kick.com/<canal>/videos/<id>",
    invalidGoogleDriveUrlFormat:
      "Formato de URL de Google Drive inválido. Usa un enlace público de archivo: /file/d/<id>/... o /open?id=<id>.",
    invalidTwitchUrlWithExample: "Formato de Twitch inválido. Ejemplo válido: {example}",
    invalidYoutubeUrlWithExample: "Formato de YouTube inválido. Ejemplo válido: {example}",
    invalidFacebookUrlWithExample: "Formato de Facebook inválido. Ejemplo válido: {example}",
    invalidKickUrlWithExample: "Formato de Kick inválido. Ejemplo válido: {example}",
    invalidGoogleDriveUrlWithExample: "Formato de Google Drive inválido. Ejemplo válido: {example}",
    unrecognizedUrlWithExamples:
      "URL no reconocida. Formatos aceptados (ejemplos): YouTube: {youtube} | Twitch: {twitch} | Kick: {kicks} | Facebook: {facebook} | Drive: {drive}",
    googleDrivePublicAccessHint:
      "Para Google Drive, el archivo debe estar compartido como \"Cualquiera con el enlace\" y permitir descarga.",
    invalidUrlFormat: "Formato de URL inválido.",
    segmentTimesRequired: "Cada segmento debe tener tiempos de inicio y fin válidos.",
    segmentStartTimeInvalid: "Cada segmento debe tener una hora de inicio válida.",
    segmentEndTimeInvalid: "Cada segmento debe tener una hora de fin válida.",
    segmentEndAfterStart: "Cada segmento debe terminar después de que comience.",
    segmentStartAfterPrevious: "El inicio debe ser después de {previousEnd} (mínimo: {minimumStart})",
    segmentEndMustBeAfterStart: "El fin debe ser mayor que el inicio",
    segmentsSequentialNoOverlap: "Los segmentos deben ser secuenciales y no superponerse.",
    unknownSource: "Desconocida",
    unrecognizedUrlOnlySupported: "URL no reconocida. Solo se admiten Twitch, YouTube, Facebook, Kick y Google Drive público.",
    queueJobError: "Error al encolar el trabajo",
    clipQueuedSuccess: "Clip encolado correctamente.",
    clipQueueError: "No se pudo encolar el clip.",
    noValidUrlsToQueue: "No hay URLs válidas para encolar.",
    batchQueueError: "Error al encolar el lote de clips",
    clipQueuedButReassignFailed: "El clip se encoló, pero no se pudo reasignar.",
    clipQueueItemError: "No se pudo encolar este clip.",
    bulkQueueAllSuccess: "Se encolaron {count} clip{suffix} correctamente.",
    bulkQueuePartialError: "Se encolaron {success} clip{suffix} y {failed} fallaron.",
    bulkQueueNone: "No se pudo encolar ningún clip. Revisa los errores en cada tarjeta.",
    detectPlatformError: "No se pudo detectar la plataforma del video.",
    untitled: "Sin título",
    metadataFetchError: "No se pudo obtener metadata.",
    metadataVerticalNotSupported: "Este video está en formato vertical. Solo admitimos videos horizontales (16:9).",
    metadataSourceAccessDenied:
      "No pudimos acceder a este video. Verifica que sea público e inténtalo de nuevo.",
    metadataSourceUnavailable:
      "Este video no está disponible, es privado o ya no existe.",
    metadataServiceUnavailable:
      "La importación de videos se está actualizando. Inténtalo de nuevo en unos minutos.",
    metadataExtractionFailed:
      "No pudimos leer la información de este video. Inténtalo de nuevo.",
    metadataRestrictedFullVod:
      "No se pudo obtener la metadata de YouTube para calcular el costo del VOD completo. Configura cookies validas de yt-dlp en el backend o define segmentos manualmente.",
    googleDriveAccessError:
      "Google Drive bloqueó el acceso al archivo por sus permisos. Cambia los permisos del archivo a \"Cualquiera con el enlace\" y asegúrate de que permita descarga.",
    googleDriveAccessErrorWithIndex:
      "Google Drive bloqueó el acceso al archivo del clip #{index} por sus permisos. Cambia los permisos del archivo a \"Cualquiera con el enlace\" y asegúrate de que permita descarga.",
    clipUrlInvalidWithIndex: "La URL del clip #{index} es inválida.",
    clipMetadataFetchErrorWithIndex: "No se pudo obtener metadata para el clip #{index}.",
    clipMetadataRestrictedWithIndex:
      "No se pudo obtener la metadata de YouTube para el clip #{index}. Configura cookies validas de yt-dlp en el backend o define segmentos manualmente para calcular el costo.",
    bulkMetadataFetchError: "No se pudo obtener metadata de los VODs.",
  },
  schedulePost: {
    processedStreams: "Streams procesados",
    processedClips: "Clips procesados",
    backToProcessedClips: "Volver al navegador",
    streamsGreetingTitle: "¡Hola, {name}! Estos son tus streams y videos procesados",
    streamsGreetingEmptyTitle: "¡Hola, {name}! Tus streams aparecerán aquí",
    streamsGreetingFallbackName: "creador",
    streamsBrowserHint: "Da clic en tus jobs para ver tus clips procesados",
    streamsGreetingEmptyHint: "Aquí verás tus streams cuando los proceses. Renderea tu primer stream para empezar a programar tus clips.",
    streamsGreetingEmptyHintEmbedded: "Cuando proceses tu primer stream, aparecerá aquí. Usa el formulario de arriba para renderear tu primer VOD.",
    stream: "stream",
    streams: "streams",
    streamUser: "Usuario (stream)",
    demoAssetsError: "No se pudo cargar el VOD de prueba.",
    demoVodTitle: "VOD de prueba",
    demoVodActionBlocked: "Este es un VOD de prueba, no se puede realizar esta accion",
    demoBadge: "DEMO",
    needRenderedVideos: "Se requieren videos renderizados para programar publicaciones.",
    noStreamsFound: "No se encontraron streams para este período",
    noStreamsFoundHint: "Aquí aparecerán tus clips cuando estén disponibles para programar.",
    noCollectionsReady: "No se encontraron colecciones de clips listas",
    collectionsReadyHint: "Las colecciones con clips listos para publicar aparecerán aquí",
    noStreamMatchFilter: "Ningún stream coincide con el filtro de usuario.",
    clip: "clip",
    readyToPost: "listos para publicar",
    statusPillReadyToPost: "listo para publicar",
    statusPillScheduled: "programado",
    statusPillPosted: "publicado",
    statusPillPostFailed: "publicación fallida",
    clips: "Clips",
    job: "Job",
    selectStreamAbove: "Selecciona un stream arriba para ver sus clips.",
    clipId: "ID",
    duration: "Duración",
    range: "Rango",
    timeRange: "Rango de tiempo",
    schedule: "Programar",
    publish: "Publicar",
    clipActions: "Acciones del clip",
    clipActionsShort: "Acciones",
    viewClips: "Ver clips",
    of: "de",
    clipsPage: "Página",
    backToVods: "Volver a VODs",
    clipDetails: "Detalles del clip",
    noPreviewAvailable: "La vista previa no está disponible",
    downloading: "Descargando...",
    deleting: "Eliminando...",
    noReadyClipsInCollection: "No hay clips listos en esta colección.",
    calendarTimeline: "Línea temporal del calendario",
    fullCalendar: "Calendario completo",
    noVideoYet: "sin video aún",
    noClipYet: "sin clip aún",
    noClipsFound: "sin clips agendados",
    scheduleClip: "Programar clip",
    previousClip: "Clip anterior",
    nextClip: "Clip siguiente",
    reviewBeforeDate: "Revisa plataformas y campos antes de elegir fecha y hora de publicación.",
    generalSettings: "Detalles",
    title: "Título",
    titleAllPlatforms: "Título usado en todas las plataformas",
    description: "Descripción",
    descriptionPlaceholder: "Subtítulo / descripción",
    options: "Opciones",
    asyncUpload: "Subida asíncrona",
    platforms: "Plataformas",
    platformStripHint:
      "Activa el interruptor para publicar en esa red. Pulsa el logo para abrir la configuración de esa plataforma.",
    networkToggleHint: "Selecciona dónde se publicará este clip.",
    platformSwitchOn: "Activar",
    platformSwitchOff: "Desactivar",
    platformEnableByTap: "Toca para activar",
    platformDisableByTap: "Toca para desactivar",
    publishEnabled: "Seleccionada",
    publishDisabled: "No seleccionada",
    platformUnavailable: "No seleccionada",
    platformDisconnected: "No conectada",
    openPlatformSettingsA11y: "Abrir configuración de",
    connectSocialPromptTitle: "Conecta tus redes sociales",
    connectSocialPromptSubtitle: "Necesitas al menos una red conectada para programar clips.",
    connectSocialPromptBody:
      "Ve a Configuración para conectar tus redes sociales y volver a programar este clip.",
    connectSocialPromptContinue: "Continuar",
    returnToSchedule: "Volver a programación",
    openingConnection: "Abriendo conexión...",
    openningconnection: "Abriendo conexión...",
    saving: "Guardando...",
    scheduling: "Programando...",
    saveAndSchedule: "Guardar y programar",
    saveScheduledChanges: "Guardar cambios",
    editScheduledMetadata: "Editar programación",
    chooseDateTime: "Fecha y hora",
    stepCurrent: "Paso actual",
    stepDone: "Completado",
    stepNext: "Siguiente",
    stepPending: "Pendiente",
    confirmPublishWhen: "Confirma cuándo se publicará el clip.",
    scheduleQuestionPrefix: "¿Programar",
    forThe: "para el",
    forSelectedDate: "para la fecha seleccionada?",
    selectDateBelow: "Selecciona una fecha abajo.",
    timezone: "Zona horaria",
    selectTimezone: "Selecciona zona horaria",
    selectTimezoneHint: "Selecciona una zona horaria",
    postingDateLabel: "Línea de tiempo de publicación",
    postingTime: "Hora de publicación",
    hour: "Hora",
    minute: "Minuto",
    selectPostingTimeHint: "Selecciona una hora de publicación",
    manageScheduledSubtitle: "Detalles y acciones para esta publicación.",
    manageScheduledBody: "Estás gestionando la publicación programada de este clip. Los datos se muestran a continuación.",
    deleteStepOne: "Este clip dejará de estar disponible en la programación.",
    deleteReviewHint: "Revisa el clip antes de confirmar; podrás cancelar con el botón inferior.",
    deleteStepTwoWarning: "Si continúas, el clip será eliminado y no volverá a aparecer en esta vista.",
    period1d: "1 día",
    period3d: "3 días",
    period7d: "7 días",
    scopeAllUsers: "Todos los usuarios",
    scopeMyClips: "Solo mis clips",
    scopeMyUsers: "Solo mis usuarios",
    errorSelectDate: "Por favor selecciona una fecha",
    errorSelectPostingTime: "Por favor selecciona una hora de publicación",
    errorSelectTimezone: "Por favor selecciona una zona horaria",
    errorLoginToSchedule: "Debes iniciar sesión para programar un clip.",
    errorInvalidDate: "Fecha inválida",
    errorTimeTooClose: "La hora seleccionada está demasiado cerca. Elige una hora un poco más tarde.",
    errorChooseFutureTime: "Por favor elige una hora futura",
    errorScheduleClip: "Error al programar el clip",
    errorGenerateConnectionLink: "No se pudo generar el enlace de conexión",
    errorLoginToCancelUpload: "Debes iniciar sesión para cancelar la subida.",
    scheduledAt: "Programado",
    errorNoClipSelected: "No hay clip seleccionado",
    errorNoTitle: "El título es obligatorio.",
    errorNoConnectedPlatforms:
      "No tienes redes sociales conectadas para programar este clip. Conecta al menos una desde tu perfil.",
    errorLoginToSaveMetadata: "Debes iniciar sesión para guardar los metadatos.",
    errorOpenSettings: "No se pudo abrir configuración.",
    errorOpenSocialConnection: "No se pudo abrir la conexión social.",
    errorUpdateMetadata: "No se pudo actualizar los metadatos del clip",
    metadataSavedFor: "Metadatos guardados para",
    errorSavingMetadata: "Error al guardar los metadatos.",
    instagramSettings: "Configuración de Instagram",
    tiktokSettings: "Configuración de TikTok",
    youtubeSettings: "Configuración de YouTube",
    facebookSettings: "Configuración de Facebook",
    facebookPublishHint:
      "Los videos se publicarán en la página de Facebook conectada en tu perfil.",
    facebookPageId: "Página de Facebook",
    facebookPageSelectPlaceholder: "Selecciona una página",
    loadingFacebookPages: "Cargando páginas de Facebook...",
    facebookPagesLoadError: "No se pudieron cargar tus páginas de Facebook.",
    facebookPagesEmpty: "No hay páginas de Facebook disponibles para esta cuenta.",
    facebookPageUnknownName: "Página guardada",
    errorFacebookPageIdRequired: "Debes seleccionar una página de Facebook antes de programar este clip.",
    xSettings: "Configuración de X (Twitter)",
    xPublishHint:
      "Las publicaciones se enviarán a la cuenta de X (Twitter) conectada en tu perfil.",
    selectPlatformToPreview: "no se tienen redes sociales seleccionadas",
    likesLabel: "Me gusta",
    commentsLabel: "Comentarios",
    shareLabel: "Compartir",
    tags: "Etiquetas",
    tagsPlaceholder: "tag1, tag2",
    tagsCommaHint: "Etiquetas separadas por comas",
    tagsDuplicate: "El hashtag ya existe.",
    selectedNetwork: "Red seleccionada",
    defaultLanguage: "Idioma predeterminado",
    iso639Hint: "Código ISO 639-1",
    selectFacebookForSettings:
      "Selecciona Facebook para configurar metadatos específicos en este modal.",
    selectAtLeastOnePlatform: "Selecciona al menos una plataforma en Configuración general para configurar los metadatos específicos de cada plataforma.",
    loadJobsError: "No se pudieron cargar los jobs.",
    loadClipsError: "No se pudieron cargar los clips.",
    missingRenderedVideosFor: "Faltan videos renderizados para",
    clipNotFound: "Clip no encontrado",
    loadClipDetailsError: "Error al cargar los detalles del clip",
    cancelUploadError: "No se pudo cancelar la subida del clip",
    uploadCancelledFor: "Subida cancelada para",
    collectionProcessingModalTitle: "Stream en procesamiento",
    collectionProcessingModalTitleQueued: "En cola de procesamiento",
    collectionProcessingModalTitleDownloading: "Descargando stream",
    collectionProcessingModalTitleDownloaded: "Procesando stream",
    collectionProcessingModalTitleDecided: "En cola de renderizado",
    collectionProcessingModalTitleRendering: "Creando tus clips",
    collectionProcessingModalTitleFailed: "Procesamiento fallido",
    collectionProcessingModalMessage:
      "Este stream aún se está procesando. Sé paciente, pronto podrás abrir la colección.",
    collectionProcessingModalMessageQueued:
      "Tu stream está en cola. Sé paciente, pronto comenzará el procesamiento.",
    collectionProcessingModalMessageDownloading:
      "Estamos descargando tu stream. Sé paciente, esto terminará pronto.",
    collectionProcessingModalMessageDownloaded:
      "El stream ya se descargó y estamos preparando tus clips. Pronto terminará.",
    collectionProcessingModalMessageDecided:
      "Tu stream está en cola para renderizarse. Sé paciente, falta poco.",
    collectionProcessingModalMessageRendering:
      "Estamos renderizando tus clips. Sé paciente, ya casi terminamos.",
    collectionProcessingModalMessageFailed:
      "Lamentamos los inconvenientes. Verificaremos el error y nos contactaremos contigo por correo para compensarte.",
    collectionProcessingCurrentStatus: "Estado actual:",
    collectionActionsMenuAria: "Abrir acciones de la colección",
    scrollCollectionsLeft: "Desplazar fila a la izquierda",
    scrollCollectionsRight: "Desplazar fila a la derecha",
    scrollClipsLeft: "Desplazar clips a la izquierda",
    scrollClipsRight: "Desplazar clips a la derecha",
    previewDefaultTitle: "Tu clip está listo para publicarse",
    previewDefaultHandle: "tu_canal",
    previewPickDateTime: "Elige fecha y hora para publicar",
    previewPendingTime: "hora pendiente",
    autoGeneratedClips: "Clips creados automáticamente",
    yourConnectedNetworks: "Tus redes conectadas",
    connectedPlatforms: "Redes conectadas",
    magicPublish: "Publicación mágica",
    publishNow: "Programar",
    selectPublishNetworks: "Selecciona las redes de publicación",
    selectDate: "Selecciona la fecha",
    selectTime: "Selecciona la hora",
    selectTimezoneLabel: "Selecciona la zona horaria",
    pickHour: "Elige hora",
    pickMinute: "Elige minuto",
    pickTimeHint: "Selecciona hora, minuto y AM o PM.",
    pickTimeHintShort: "Aún no has elegido la hora",
    dayPeriod: "Periodo del día",
    editClip: "Editar clip",
    sourceVod: "VOD de origen",
    checkingConnection: "Verificando...",
    platformConnected: "Conectada",
    platformNotConnected: "Sin conectar",
    errorLoadAdminTimeline: "No fue posible cargar la timeline.",
    errorLoginToLoadTimeline: "Debes iniciar sesión para consultar la timeline.",
    converterFolderTitle: "Converter PRO",
    converterFolderSubtitle: "Convierte videos completos de Google Drive (max 5 minutos) en una sola cola.",
    converterFolderHandle: "Google Drive",
    converterFolderOwner: "Converter PRO",
    converterFolderBadge: "CONVERTER",
    converterFolderSummary: "Conversiones de Google Drive",
    converterPanelTitle: "Convierte tu video completo de Drive",
    converterPanelSubtitle: "Pega una URL publica de Google Drive (max. 5 minutos), elige tipo de video y confirma para procesar el video completo.",
    converterStartFullVideo: "Convertir video completo",
    converterDrivePlaceholder: "https://drive.google.com/file/d/...",
    converterPrepareCta: "Preparar clip",
    converterInvalidDriveUrl: "Ingresa una URL valida de Google Drive.",
    converterNoHistory: "Aun no tienes conversiones en este folder.",
    converterPrepareConfirmSubtitle: "Verifica el resumen antes de encolar la conversion del video completo de Google Drive.",
    converterDurationMax: "Maximo 5 minutos",
    converterTokenChargeHint: "El cobro final usa la duracion real detectada por el worker al procesar el video completo.",
    converterSelectionLabel: "Rango seleccionado",
    converterWatchRender: "Ver render",
    converterStatusPreparing: "Preparando",
    converterStatusQueuedRender: "En cola para render",
    converterStatusQueued: "En cola",
    converterStatusDownloading: "Descargando",
    converterStatusProcessing: "Procesando",
    converterStatusRendering: "Renderizando",
    converterStatusReadyToEdit: "Listo para editar",
    converterStatusFailed: "Fallido",
    converterStatusRendered: "Renderizado",
    converterActionRendered: "Clip renderizado",
    converterActionFailed: "Error en conversion",
    converterActionProcessing: "Procesando video completo",
    converterLoadError: "No se pudo cargar el historial de converter.",
    converterPrepareError: "No se pudo encolar la conversion del video.",
    converterConfirmTitle: "Confirmar conversion de video completo",
    converterEditorTitle: "Editor Converter PRO",
    converterEditorNoTitle: "Converter job",
    converterEditorTab: "Editor",
    converterVideoTypeTab: "Tipo de video",
    converterEndCardTab: "End-card",
    converterSummaryTab: "Resumen",
    converterDurationHint: "Duracion seleccionada",
    converterEndCardHint: "El end-card se aplicara con la configuracion actual del render.",
    converterSummaryDuration: "Duracion seleccionada",
    converterSummaryVideoType: "Tipo de video",
    converterSummaryTokens: "Tokens a cobrar",
    converterRenderConfirm: "Editar y renderizar",
    converterRenderError: "No se pudo encolar el render del converter.",
    converterConfirmAndQueue: "Confirmar y convertir video",
    backToStreams: "Regresar a streams",
    selectAll: "Todos",
    clearSelection: "Quitar",
    download: "Descargar",
    downloadZip: "Descargar ZIP",
    preparingZip: "Preparando ZIP",
    zipDownloadSuccess: "ZIP descargado correctamente",
    selectClipForDownload: "Seleccionar clip para descargar",
  },
  vodClips: {
    subtitlesToggleLabel: "Mostrar subtítulos",
    vodStatus: "Estatus VOD",
    noCollections: "No se encontraron colecciones de clips",
    noCollectionsHint: "Crea clips de un VOD de Twitch para empezar",
    vod: "VOD",
    processing: "Procesando",
    downloading: "Descargando",
    preparingClips: "Preparando clips",
    creatingClips: "Creando tus clips",
    rendering: "Renderizando",
    inQueue: "En cola",
    validating: "Validando",
    vodList: "Lista de VODs",
    clipCandidates: "Candidatos de clips",
    reassignVod: "Reasignar VOD",
    deleting: "Eliminando...",
    deleteVod: "Eliminar VOD",
    sendToError: "Enviar a error",
    sendingToError: "Enviando...",
    rerenderVod: "Volver a renderear",
    rerenderVodFull: "Volver a descargar y renderear",
    rerenderFailedClips: "Re-renderear clips fallidos",
    rerenderingVod: "Reencolando...",
    backToVods: "Volver a VODs",
    previewWarning: "Aviso importante: Esta es una previsualización. Aún no hay captions (se agregan al render final), el video está en horizontal pero se convertirá a vertical centrado en el rostro, y la calidad aquí es baja; el resultado final se entrega en alta calidad.",
    vodUrl: "URL del VOD",
    publicUrl: "URL pública",
    copy: "Copiar",
    period1d: "1 día",
    period3d: "3 días",
    period7d: "7 días",
    periodAll: "Todos",
    statusAll: "Todos",
    statusQueued: "En cola",
    statusRunning: "En ejecución",
    statusDownloading: "Descargando",
    statusRendering: "Renderizando",
    statusDownloaded: "Descargado",
    statusDecided: "Decidido",
    statusScheduling: "Programando",
    statusRendered: "Renderizado",
    statusPublished: "Publicado",
    statusExpired: "Expirado",
    statusInsufficientTokens: "Tokens insuficientes",
    renderingModalTitle: "Renderizando",
    renderingModalMessage: "Este video se está renderizando.",
    publishedModalTitle: "Video ya publicado",
    publishedModalMessage: "Este VOD ya fue publicado.",
    statusFailed: "Fallido",
    failureNoSpeechIntroScan: "No se detecto voz",
    failureSourceVideoTooShort: "El stream/video es demasiado corto, intenta con uno más largo",
    failureSourceSubscriberOnly: "Este VOD de Kick está configurado solo para suscriptores activos. Cambia la configuración del VOD a público.",
    statusCancelled: "Cancelado",
    publicUrlCopied: "URL pública copiada.",
    publicUrlCopyError: "No se pudo copiar la URL pública.",
    vodUrlCopied: "URL del VOD copiada.",
    vodUrlCopyError: "No se pudo copiar la URL del VOD.",
    vodRendering: "VOD renderizando",
    clipsRendered: "clips renderizados",
    clipsInReview: "Clips en revisión",
    noClipsYet: "Aún no se han generado clips",
    clipTime: "Tiempo del clip",
    fullscreen: "Pantalla completa",
    exitFullscreen: "Salir de pantalla completa",
    mute: "Silenciar",
    unmute: "Activar sonido",
    play: "Reproducir",
    pause: "Pausar",
    playPreview: "Reproducir vista previa",
    pausePreview: "Pausar vista previa",
    loadingPreview: "Cargando vista previa",
    previewTimeline: "Línea de tiempo de la vista previa",
    mutePreview: "Silenciar vista previa",
    unmutePreview: "Activar sonido de la vista previa",
    playClipAria: "Reproducir clip",
    thumbnailAltPrefix: "Miniatura",
    editor: "Editor",
    start: "Inicio",
    end: "Fin",
    duration: "Duración",
    video: "Vídeo",
    edited: "Editado",
    editedTimingTooltip: "Este clip tiene un rango de tiempo editado (inicio/fin).",
    reason: "Razón",
    clipContext: "Contexto del clip",
    addShortContext: "Agregar contexto breve",
    contextPlaceholder: "Ej: Momento épico del stream...",
    accept: "Aceptar",
    reject: "Rechazar",
    pendingClipsDetected: "Clips pendientes detectados",
    pendingInfoPart1: "Algunos clips siguen sin decidir. Si continúas, todos los pendientes se marcarán automáticamente como",
    pendingQuestion: "¿Quieres continuar y rechazar todos los clips pendientes restantes?",
    pendingInfoPart2: "y se guardarán.",
    rejectedLower: "rechazados",
    undecidedSuffix: "sin decidir",
    pendingPlural: "Pendientes",
    acceptedPlural: "Aceptados",
    rejectedPlural: "Rechazados",
    rejectPendingAndSave: "Rechazar pendientes y guardar",
    clipEditorTitle: "Editor de clips",
    correctTranscript: "Corregir transcripción",
    transcriptVisibleRange: "Solo se muestran los bloques dentro del rango seleccionado.",
    transcriptCorrectionOnly: "Uso exclusivo para corregir malas interpretaciones, ortografía o censurar.",
    transcriptSyncWarning: "Agregar o eliminar palabras puede desincronizar los subtítulos.",
    transcriptCensorHint: "Tres o más asteriscos consecutivos silencian la zona central de esa palabra.",
    transcriptCensorExamples: "Ejemplos: p***ta, mier****.",
    transcriptNoBlocksInRange: "No hay bloques de transcripción dentro del rango seleccionado.",
    transcriptLoadError: "No se pudo cargar la transcripción.",
    applyTranscriptChanges: "Aplicar al editor",
    job: "Trabajo",
    currentRange: "Rango actual",
    centerOriginalClip: "Centro (clip original)",
    dragToMoveSelection: "Arrastra para mover la selección",
    adjustStartDrag: "Ajustar inicio (arrastra)",
    selected: "Seleccionado",
    adjustEndDrag: "Ajustar fin (arrastra)",
    newRange: "Nuevo rango",
    extra: "Extra",
    addMusic: "Agregar música",
    song: "Canción",
    selectSong: "Selecciona una canción",
    songStartSeconds: "Inicio canción (segundos)",
    musicTimeline: "Timeline música",
    volume: "Volumen",
    previewNewStart: "Ir al nuevo inicio en el reproductor del modal",
    preview: "Vista previa",
    videoTypeTab: "Video type",
    contextTab: "Contexto",
    videoTypeLabel: "Tipo de video",
    videoTypeWarning: "Elige el tipo de video solo si estás seguro. Si el formato elegido no coincide con el contenido, el sistema puede usar una vista vertical centrada y solo se verá el centro de la pantalla.",
    videoTypeAuto: "Auto",
    videoTypeGameplay: "Pantalla dividida",
    videoTypeJustChatting: "Estándar",
    videoTypeIRL: "Video completo",
    videoTypePodcast: "Podcast",
    videoTypeCenter: "Vertical centrado",
    videoTypeGuideTitle: "Qué hace cada categoría",
    videoTypeAutoDescription: "El worker analiza el clip y decide automáticamente el layout más adecuado entre gameplay, podcast o formato vertical conversacional.",
    videoTypeGameplayDescription: "Tu cámara arriba, tu contenido abajo.",
    videoTypeJustChattingDescription: "Una sola toma, centrada.",
    videoTypeIRLDescription: "Se ve todo, con fondo difuminado.",
    videoTypePodcastDescription: "Varias personas en pantalla.",
    videoTypeCenterDescription: "Esta categoría fuerza un encuadre vertical fijo al centro del video completo, sin priorizar detección de rostro.",
    contextPreviewHint: "Esta vista previa usa el video de edición para simular el layout IRL vertical. El resultado final puede variar después del re-render.",
    editorOriginalStreamLabel: "Transmisión original",
    editorClipPreviewLabel: "Vista previa del clip",
    editorRenderVarianceHint: "El render final puede verse un poco distinto a esta vista previa.",
    editorSubtitlePlaceholder: "Tus subtítulos irán aquí",
    layoutJustChattingCropLabel: "Video vertical",
    layoutGameplayCropLabel: "Gameplay",
    layoutFaceCropLabel: "Rostro",
    layoutDragHint: "Arrastra los recuadros sobre el video horizontal para elegir el encuadre del clip vertical.",
    podcastPreviewUnavailable: "Vista previa no disponible para podcast",
    previewLayoutSaveError: "No se pudo guardar el encuadre para este clip.",
    contextOnlyIrl: "Solo puedes mover el contexto cuando el tipo de video es IRL.",
    contextBoxToggleLabel: "Mostrar cuadro de contexto",
    contextBoxDisabledHint: "El clip IRL se renderizará sin cuadro de contexto.",
    contextTextInputLabel: "Texto de contexto",
    contextTextInputPlaceholder: "Escribe o mejora el contexto que aparecerá en el clip IRL.",
    contextCompatibleEmojiTitle: "Emojis compatibles",
    contextCompatibleEmojiHint: "Estos símbolos sí se renderizan en el video final.",
    insertContextEmoji: "Insertar emoji",
    contextDragHint: "Arrastra la caja para elegir dónde aparecerá el contexto en clips IRL.",
    contextEmojiLabels: {
      happy: "Feliz",
      sad: "Triste",
      heart: "Corazón",
      classicHeart: "Corazón clásico",
      star: "Estrella",
      starOutline: "Estrella contorno",
      sparkle: "Destello",
      sparkleOutline: "Destello contorno",
      sun: "Sol",
      cloud: "Nube",
      rain: "Lluvia",
      snow: "Nieve",
      lightning: "Rayo",
      coffee: "Café",
      music: "Música",
      musicNote: "Nota musical",
      check: "Check",
      cross: "Equis",
      plane: "Avión",
      flag: "Bandera",
      flagOutline: "Bandera contorno",
      clover: "Trébol",
      moon: "Luna",
      moonOutline: "Luna contorno",
      crown: "Corona",
      blackCrown: "Corona negra",
      gear: "Engrane",
      swords: "Espadas",
      anchor: "Ancla",
      warning: "Advertencia",
    },
    contextTextMissing: "Este clip no tiene texto de contexto generado por IA.",
    contextSaveError: "No se pudo guardar el contexto de este clip.",
    premiumEditorRequiresPremium: "Necesitas una suscripción premium activa para editar este clip.",
    premiumEditorScheduledBlocked: "Cancela la publicación programada para poder editar este clip.",
    premiumEditorPostedBlocked: "Este clip ya fue publicado y no se puede editar.",
    premiumEditorNotEditable: "Este clip no se puede editar.",
    premiumEditorMissingEditSource: "Este clip todavía no tiene video de edición disponible.",
    premiumEditorVideoLoadFailed: "No se pudo cargar el video de edición de este clip.",
    premiumEditorOriginalExpired: "Este clip ya no se puede editar porque el video original venció.",
    premiumEditorRerenderQueued: "Re-render encolado. El clip se actualizará en unos minutos.",
    premiumEditorRangeInvalid: "El nuevo rango debe mantenerse dentro de ±15 segundos del clip actual.",
    premiumEditorRerenderError: "No se pudo encolar el re-render del clip. Inténtalo de nuevo.",
    personalizationSaveError: "No se pudo guardar la personalización antes de re-renderear.",
    selectUserToReassign: "Selecciona un usuario para reasignar este VOD.",
    confirmDeleteVodTitle: "Confirmar eliminación de VOD",
    deleteVodPermanent: "Esta acción es permanente y no se puede deshacer.",
    deleteVodWarning: "Una vez eliminado, este VOD ya no podrá ser restaurado.",
    name: "Nombre",
    date: "Fecha",
    loadUsersError: "No se pudieron cargar usuarios",
    loadUsersErrorShort: "No se pudieron cargar los usuarios.",
    noUsersMatchFilter: "Ningún usuario coincide con el filtro.",
    selectedUserIdNotFound: "No se encontró el user_id del usuario seleccionado.",
    vodReassignedTo: "VOD reasignado a",
    selectedUser: "usuario seleccionado",
    reassignVodError: "No se pudo reasignar el VOD. Inténtalo de nuevo.",
    authRequired: "Se requiere autenticación",
    missingApiUrl: "Falta VUE_APP_API_URL",
    deleteVodError: "Error al eliminar el VOD",
    vodDeleted: "VOD eliminado.",
    deleteVodRetryError: "Error al eliminar el VOD. Por favor, inténtalo de nuevo.",
    releaseStuckTitle: "Enviar VOD a error",
    releaseStuckSubtitle: "Esta acción libera jobs atorados y conserva clips ya renderizados.",
    releaseStuckWarning: "Si el job tenía descarga o clips renderizados, quedará en Renderizado y solo se marcarán como fallidos los clips incompletos.",
    releaseStuckError: "No se pudo enviar el VOD a error. Inténtalo de nuevo.",
    releaseStuckRenderedSuccess: "VOD liberado. Se conservaron los clips renderizados.",
    releaseStuckFailedSuccess: "VOD enviado a error correctamente.",
    rerenderVodConfirmTitle: "Volver a descargar y renderear VOD",
    rerenderVodConfirmSubtitle: "Se eliminarán los clips actuales y se volverá a encolar el VOD.",
    rerenderVodWarning: "Solo usa esta opción cuando haya fallado la descarga. El sistema reiniciará el procesamiento desde cero.",
    rerenderFailedClipsSubtitle: "Solo se volverán a encolar los clips en estado fallido.",
    rerenderFailedClipsWarning: "Esta opción conserva clips buenos y solo recupera clips fallidos.",
    rerenderVodSuccess: "El VOD se volvió a encolar correctamente.",
    rerenderVodError: "No se pudo volver a descargar y renderear el VOD. Inténtalo de nuevo.",
    rerenderFailedClipsError: "No se pudieron re-renderizar los clips fallidos. Inténtalo de nuevo.",
    rerenderFailedClipsSuccess: "Clips fallidos reencolados correctamente.",
    statusRerenderFailed: "Re-render fallido",
    publicJobIdNotFound: "No se encontró el job_id en la URL pública.",
    loadCollectionsError: "Ocurrió un error al cargar las colecciones. Por favor, inténtalo de nuevo.",
    vodExpiredOpenSnackbar: "El VOD al que desea ingresar ha expirado, por favor renderea uno nuevo.",
    unknown: "Desconocido",
    unsavedDecisionChangesWarning: "Tienes cambios sin guardar en clips aceptados/rechazados. ¿Seguro que quieres salir sin guardar?",
  },
  twitchPostAdmin: {
    timelineUsers: "Timeline de usuarios",
    users: "Usuarios",
    total: "Total",
    scheduled: "Programadas",
    posted: "Publicados",
    usernameFilterPlaceholder: "Buscar nombre de usuario",
    addUsernameFilter: "Agregar",
    clearUsernameFilters: "Limpiar",
    removeUsernameFilter: "Quitar filtro de usuario",
    showMyUsers: "Mostrar mis usuarios",
    showAllUsers: "Mostrar todos los usuarios",
    assignAdmin: "Assign",
    assignAdminTitle: "Asignar admin",
    timelineUser: "Assign user",
    unassignedAdmin: "Sin asignar",
    assignedAdminUnknown: "Admin asignado",
    closeAssignAdmin: "Cerrar asignación de admin",
    loadingAdmins: "Cargando admins...",
    noAdminsAvailable: "No hay admins disponibles.",
    searchAdminPlaceholder: "Buscar admin",
    noAdminsMatchFilter: "Ningún admin coincide con la búsqueda.",
    assigningAdmin: "Asignando...",
    noUsersTimeline: "No hay usuarios habilitados para timeline.",
    noFilteredUsersTimeline: "No hay timelines para los usuarios filtrados.",
    noPosts: "sin publicaciones",
    previewTitle: "Preview de clip programado",
    untitledClip: "Clip sin título",
    closePreview: "Cerrar preview",
    loadingPreview: "Cargando preview...",
    noVideo: "No hay video disponible para este clip.",
    user: "Usuario",
    time: "Hora",
    status: "Estado",
    publishedUrls: "URLs publicadas",
    stream: "Stream",
    manageScheduledClip: "Administrar clip programado",
    closeManageScheduledClip: "Cerrar administrar clip",
    clipId: "ID del clip",
    scheduledDate: "Fecha programada",
    scheduledTime: "Hora programada",
    cancellingUpload: "CANCELANDO...",
    cancelUpload: "CANCELAR SUBIDA",
    previewLoadError: "No fue posible cargar la preview del clip.",
    previewUrlMissing: "No se encontró URL de preview para este clip programado.",
  },
  publicResults: {
    title: "Clips renderizados",
    job: "Tarea",
    empty: "No se encontraron clips renderizados para esta tarea.",
    score: "PUNTAJE",
    downloading: "Descargando...",
    download: "Descargar",
    deleting: "Eliminando...",
    confirmDelete: "Confirmar eliminación",
    lastConfirmation: "Última confirmación",
    deleteStepOne: "Este clip dejará de mostrarse en resultados públicos.",
    deleteStepTwo: "Esta acción es permanente y no se podrá deshacer.",
    selectedClip: "Clip seleccionado",
    deleteWarning: "Si continúas, el clip será eliminado y ya no volverá a estar disponible.",
    yesContinue: "Sí, continuar",
    yesDeletePermanent: "Sí, eliminar definitivamente",
    downloadError: "No se pudo descargar el clip.",
    downloadSuccess: "Clip descargado correctamente",
    downloadRetryError: "Error al descargar el clip. Inténtalo de nuevo.",
    deleteError: "No se pudo eliminar el clip.",
    deleteSuccess: "Clip eliminado",
    deleteRetryError: "Error al eliminar el clip. Inténtalo de nuevo.",
    invalidJobId: "ID de tarea inválido.",
    jobIdNotFound: "ID de tarea no encontrado en la URL.",
    status: {
      pending: "Pendiente",
      processing: "Procesando",
      rendering: "Renderizando",
      completed: "Completado",
      failed: "Fallido",
      accepted: "Aceptado",
      rejected: "Rechazado",
      ready: "Listo",
      rendered: "Listo",
      readyToPost: "Listo para publicar",
      posted: "Publicado",
      postFailed: "Publicación fallida",
      inProgress: "En progreso",
    },
  },
  usersList: {
    title: "Usuarios",
    impersonating: "Suplantando",
    stopImpersonation: "Detener suplantación",
    stopImpersonationTitle: "Detener suplantación de este usuario",
    addUser: "Agregar usuario",
    id: "ID",
    username: "Usuario",
    phone: "Teléfono",
    ageRange: "Edad",
    email: "Email",
    origin: "Fuente",
    plan: "Plan",
    planFilter: "Plan",
    planFilterAll: "Todos",
    planFilterFree: "Free",
    planFilterNonFree: "No Free",
    admin: "Admin",
    timezone: "Zona horaria",
    createdAt: "Creado",
    actions: "Acciones",
    loginAsUser: "Entrar como usuario",
    loadingUsers: "Cargando usuarios...",
    noUsersFound: "No se encontraron usuarios.",
    searchPlaceholder: "Buscar usuario",
    searchUsersPlaceholder: "Buscar por usuario o email",
    noUsersMatchFilter: "Ningún usuario coincide con la búsqueda.",
    originFacebookAds: "Facebook Ads",
    originAdCampaign: "Campaña",
    originAdminGenerated: "Admin",
    originOrganic: "Orgánico",
    originUnknownExisting: "Histórico",
    emptyHint: "Haz clic en \"Agregar usuario\" para crear uno.",
    editUser: "Editar usuario",
    createUser: "Crear usuario",
    personalInfo: "Información personal",
    nameRequired: "Nombre*",
    usernamePlaceholder: "Nombre de usuario",
    emailPlaceholder: "correo@ejemplo.com",
    avatarUrl: "URL del avatar",
    timezoneRequired: "Zona horaria*",
    selectTimezone: "Seleccionar zona horaria",
    accountInfo: "Información de la cuenta",
    showInPostAdminTimeline: "Mostrar en línea de tiempo en post admin",
    availableTokens: "Tokens disponibles",
    hasWatermark: "Marca de agua en clips",
    cancel: "Cancelar",
    saving: "Guardando...",
    update: "Actualizar",
    create: "Crear",
    confirmDelete: "Confirmar eliminación",
    confirmDeleteUser: "¿Seguro que quieres eliminar al usuario",
    cannotUndo: "Esta acción no se puede deshacer.",
    deleting: "Eliminando...",
    loadUsersError: "No se pudieron cargar los usuarios. Inténtalo de nuevo.",
    impersonationStarted: "Suplantación iniciada.",
    impersonationEnded: "Suplantación finalizada.",
    impersonationFailed: "No se pudo iniciar suplantación de usuario",
    avatarUrlInvalid: "La URL debe comenzar con http:// o https://",
    requiredFieldsError: "Completa correctamente todos los campos obligatorios",
    updateUserError: "No se pudo actualizar el usuario",
    createUserError: "No se pudo crear el usuario",
    updateUserRetryError: "No se pudo actualizar el usuario. Inténtalo de nuevo.",
    createUserRetryError: "No se pudo crear el usuario. Inténtalo de nuevo.",
    deleteUserError: "No se pudo eliminar el usuario",
    deleteUserRetryError: "No se pudo eliminar el usuario. Inténtalo de nuevo.",
    grantTokens: "Agregar tokens PAYG",
    grantTokensTitle: "Agregar tokens PAYG",
    targetUser: "Usuario",
    tokensToAdd: "Tokens PAYG a agregar",
    tokensPlaceholder: "Ej. 200",
    confirmGrantTokens: "Agregar tokens",
    grantingTokens: "Agregando...",
    userIdMissing: "No se encontró user_id para este usuario.",
    userIdResolveError: "No se pudo resolver el user_id del usuario.",
    invalidTokens: "Ingresa una cantidad válida de tokens (entero mayor a 0).",
    grantTokensError: "No se pudieron agregar tokens PAYG",
    grantTokensRetryError: "No se pudieron agregar tokens. Inténtalo de nuevo.",
    tokensGranted: "Tokens agregados correctamente",
    balance: "Saldo",
    sessionRequired: "Debes iniciar sesión.",
    onboardingQaTitle: "Pregunta y respuesta",
    onboardingQaButtonTitle: "Respuestas del onboarding",
    onboardingAnswerNotSet: "—",
  },
  subscriptionPlansAdmin: {
    title: "Planes de suscripción",
    subtitle: "Administra catálogo, disponibilidad y versiones históricas de planes.",
    create: "Nuevo plan",
    createFirst: "Crear primer plan",
    filterByBillingCycle: "Filtrar por ciclo de facturación",
    filterByCheckoutVisibility: "Filtrar por visibilidad en checkout",
    filterTabsAria: "Filtrar planes por período",
    visibilityTabsAria: "Filtrar planes por visibilidad en checkout",
    filterAll: "Todos",
    filterMonthly: "Mensuales",
    filterYearly: "Anuales",
    visibilityAll: "Todos",
    visibilitySelectable: "Visibles en checkout",
    visibilityHidden: "Ocultos del checkout",
    reload: "Recargar",
    reloading: "Recargando...",
    loading: "Cargando planes...",
    empty: "No hay planes disponibles.",
    emptyMonthly: "No hay planes mensuales disponibles.",
    emptyYearly: "No hay planes anuales disponibles.",
    emptySelectable: "No hay planes visibles en checkout.",
    emptyHidden: "No hay planes ocultos del checkout.",
    emptyMonthlySelectable: "No hay planes mensuales visibles en checkout.",
    emptyYearlySelectable: "No hay planes anuales visibles en checkout.",
    emptyMonthlyHidden: "No hay planes mensuales ocultos del checkout.",
    emptyYearlyHidden: "No hay planes anuales ocultos del checkout.",
    version: "Versión",
    selectable: "Seleccionable",
    edit: "Editar",
    showHistory: "Ver historial",
    hideHistory: "Ocultar historial",
    plan: "Plan",
    creditsPerPeriod: "Créditos/período",
    period: "Período",
    priceOriginal: "Precio original",
    priceLanding: "Precio landing",
    priceApp: "Precio app",
    currency: "Moneda",
    effectiveFrom: "Vigente desde",
    effectiveTo: "Vigente hasta",
    noDescription: "Sin descripción",
    versionHistory: "Historial de versiones",
    noHistory: "No hay versiones anteriores.",
    displayName: "Nombre",
    description: "Descripción",
    periodUnit: "Unidad de período",
    periodAmount: "Cantidad de períodos",
    month: "Mes",
    months: "Meses",
    year: "Año",
    years: "Años",
    yes: "Sí",
    no: "No",
    editModalTitle: "Editar plan",
    createModalTitle: "Crear plan nuevo",
    newVersion: "Nueva versión",
    planCode: "Código interno del plan",
    planCodePlaceholder: "pro_monthly_plus",
    planCodeHelpCreate: "Identificador único usado por backend. Usa letras, números, guion y guion bajo.",
    planCodeHelpLocked: "El código interno no cambia al crear nuevas versiones.",
    currentAction: "Acción",
    createNotice: "Guardar registrará un plan nuevo y lo dejará disponible para futuras suscripciones según su configuración.",
    immutableNotice: "Guardar creará una nueva versión inmutable del plan. Las suscripciones activas conservan los términos anteriores.",
    priceOriginalMarketing: "Precio original / marketing",
    priceLandingPage: "Precio landing page",
    priceAppBilling: "Precio en app / facturación real",
    availableOnCheckout: "Disponible para selección en checkout",
    cancel: "Cancelar",
    confirm: "Confirmar",
    confirmToggleTitle: "Confirmar cambio",
    saving: "Guardando...",
    saveNewPlan: "Crear plan",
    saveNewVersion: "Guardar nueva versión",
    authRequired: "Debes iniciar sesión para ver esta sección.",
    loadError: "Error al cargar planes",
    createSuccess: "Se creó el plan correctamente.",
    updateSuccess: "Se creó una nueva versión del plan correctamente.",
    createError: "No se pudo crear el plan.",
    updateError: "No se pudo guardar la nueva versión.",
    toggleSuccess: "Disponibilidad actualizada correctamente.",
    toggleError: "No se pudo actualizar la disponibilidad.",
    confirmEnableSelectable: "¿Habilitar este plan para selección en checkout?",
    confirmDisableSelectable: "¿Ocultar este plan del checkout?",
    statusActiveSelectable: "Activo y seleccionable",
    statusActiveHidden: "Activo pero oculto",
    statusInactive: "Inactivo",
    validationPlanCodeLength: "El código interno debe tener entre 2 y 80 caracteres.",
    validationPlanCodeFormat: "El código interno solo puede contener letras, números, guion y guion bajo.",
    validationDisplayName: "El nombre debe tener entre 2 y 120 caracteres.",
    validationDescription: "La descripción no puede exceder 500 caracteres.",
    validationCredits: "Los créditos por período deben ser un entero mayor a 0.",
    validationPeriodUnit: "La unidad de período es inválida.",
    validationPeriodAmount: "La cantidad de períodos debe ser un entero mayor a 0.",
    validationPrices: "Los precios deben ser números mayores o iguales a 0.",
    validationCurrency: "La moneda debe tener exactamente 3 caracteres.",
  },
  newslettersAdmin: {
    title: "Emails",
    subtitle: "Administra newsletters y marketing de Clipr.",
    tabsAria: "Secciones de Emails",
    tabNewsletters: "Newsletters",
    tabMarketing: "Marketing",
    tryLastSentAt: "Último envío",
    tryLastFailedAt: "Último fallo",
    tryCampaign: "Campaña",
    marketingTitle: "Marketing Winback",
    marketingBody: "Dashboard admin para monitorear la cola automática, estados y eventos de Winback.",
    marketingLoading: "Cargando Marketing Winback...",
    marketingLoadError: "No se pudo cargar Marketing Winback.",
    marketingStatesError: "No se pudieron cargar los estados de Marketing.",
    marketingPreviewTitle: "Preview Marketing Winback",
    marketingPreviewHelp: "Renderiza una variante winback sin enviar email.",
    marketingPreviewValidation: "Nombre y URL de unsubscribe son obligatorios.",
    marketingPreviewError: "No se pudo generar el preview de Marketing.",
    marketingAutomationTitle: "Automatización activa",
    marketingAutomationHelp: "El cron sincroniza candidatos aptos y envía máximo 6 correos por corrida. Esta pantalla solo monitorea cola, estados y eventos.",
    marketingNoCampaigns: "No hay deliveries de Marketing registrados.",
    marketingStates: "Estados Marketing",
    marketingStatesLoading: "Cargando estados de Marketing...",
    marketingNoStates: "No hay estados de Marketing para esos filtros.",
    marketingUnsubscribed: "Desuscritos",
    marketingOpens: "Opens",
    marketingClicks: "Clicks",
    marketingConversions: "Conversiones",
    marketingByCycle: "Por ciclo",
    marketingByStep: "Por step",
    marketingBySegment: "Por segmento",
    marketingByTokenState: "Por token_state",
    marketingStatusActive: "Activo",
    marketingStatusCooldown: "Cooldown",
    marketingStatusConverted: "Convertido",
    marketingStatusExhausted: "Exhausted",
    marketingStatusPaused: "Pausado",
    marketingSegmentGenerated: "Generó contenido",
    marketingSegmentNotGenerated: "Sin contenido generado",
    marketingTokenHasTokens: "Con tokens",
    marketingTokenNoTokens: "Sin tokens",
    marketingEngagementCold: "Frío",
    marketingEngagementWarm: "Tibio",
    marketingEngagementEngaged: "Engaged",
    totalStates: "Estados",
    totalDeliveries: "Deliveries",
    processed: "Procesados",
    eligible: "Elegibles",
    skipped: "Omitidos",
    createdDeliveries: "Deliveries creados",
    reasons: "Razones",
    campaign: "Campaña",
    filterByEmail: "Filtrar por email",
    search: "Buscar",
    clear: "Limpiar",
    breakdown: "Breakdown",
    noData: "Sin datos",
    segment: "Segmento",
    tokenState: "Tokens",
    cycle: "Ciclo",
    step: "Step",
    engagement: "Engagement",
    openedAt: "Open",
    clickedAt: "Click",
    convertedAt: "Convertido",
    unsubscribeUrl: "URL unsubscribe",
    create: "Nueva newsletter",
    createFirst: "Crear primera newsletter",
    generate: "Generar con IA",
    generateTitle: "Generar newsletters con IA",
    generateHelp: "La IA solo crea borradores. Un admin debe revisarlos y aprobarlos antes de enviar.",
    generateCount: "Cantidad",
    generateLanguage: "Idioma",
    generateLanguageEs: "Espanol",
    generateLanguageEn: "Ingles",
    generateTopics: "Temas",
    generateTopicsHelp: "Escribe un tema por linea. El backend usa un prompt fijo y valida que la respuesta complete la plantilla.",
    generating: "Generando...",
    generateDrafts: "Generar borradores",
    reload: "Recargar",
    reloading: "Recargando...",
    filterByStatus: "Filtrar por estado",
    loading: "Cargando newsletters...",
    empty: "No hay newsletters disponibles.",
    newsletter: "Newsletter",
    subject: "Asunto",
    status: "Estado",
    scheduledAt: "Programada",
    updatedAt: "Actualizada",
    actions: "Acciones",
    preview: "Preview",
    edit: "Editar",
    approve: "Aprobar",
    reject: "Rechazar",
    schedule: "Programar",
    sendTest: "Enviar test",
    deliveries: "Deliveries",
    delete: "Eliminar",
    editModalTitle: "Editar newsletter",
    createModalTitle: "Crear newsletter",
    editorHelp: "Completa los campos usados por la plantilla HTML para que el preview y el envio no fallen.",
    internalTitle: "Titulo interno",
    emailSubject: "Asunto del email",
    cancel: "Cancelar",
    saving: "Guardando...",
    save: "Guardar",
    previewTitle: "Preview de newsletter",
    previewName: "Nombre para preview",
    previewEmail: "Email para preview",
    loadingShort: "Cargando...",
    refresh: "Actualizar",
    loadingPreview: "Generando preview...",
    sendTestTitle: "Enviar email de prueba",
    recipientName: "Nombre",
    recipientEmail: "Email",
    sending: "Enviando...",
    send: "Enviar",
    scheduleTitle: "Programar newsletter",
    scheduleHelp: "Se enviara al backend como fecha UTC con timezone.",
    deliveriesTitle: "Deliveries",
    deleteTitle: "Eliminar newsletter",
    deleteWarning: "Esta accion eliminara permanentemente la plantilla y no se puede deshacer.",
    deleting: "Eliminando...",
    confirmDelete: "Eliminar permanentemente",
    total: "Total",
    pending: "Pendientes",
    sent: "Enviados",
    cancelled: "Cancelados",
    failed: "Fallidos",
    email: "Email",
    sentAt: "Enviado",
    error: "Error",
    noDeliveries: "No hay deliveries para esta newsletter.",
    loadingDeliveries: "Cargando deliveries...",
    statusAll: "Todos",
    statusDraft: "Borrador",
    statusApproved: "Aprobada",
    statusRejected: "Rechazada",
    statusScheduled: "Programada",
    statusSending: "Enviando",
    statusSent: "Enviada",
    statusCancelled: "Cancelada",
    authRequired: "Debes iniciar sesion para ver esta seccion.",
    loadError: "No se pudieron cargar newsletters.",
    validationTitleSubject: "Titulo y asunto son obligatorios.",
    validationContent: "Completa todos los campos de contenido.",
    generateCountValidation: "La cantidad debe estar entre 1 y 30.",
    generateLanguageValidation: "Selecciona un idioma valido.",
    generateTopicsValidation: "Agrega al menos un tema.",
    generateSuccess: "{count} newsletters generadas correctamente.",
    generateError: "No se pudieron generar newsletters.",
    createSuccess: "Newsletter creada correctamente.",
    updateSuccess: "Newsletter actualizada correctamente.",
    saveError: "No se pudo guardar la newsletter.",
    approveSuccess: "Newsletter aprobada correctamente.",
    approveError: "No se pudo aprobar la newsletter.",
    rejectSuccess: "Newsletter rechazada correctamente.",
    rejectError: "No se pudo rechazar la newsletter.",
    previewValidation: "Nombre y email de preview son obligatorios.",
    previewError: "No se pudo generar el preview.",
    sendTestSuccess: "Email de prueba enviado correctamente.",
    sendTestError: "No se pudo enviar el email de prueba.",
    scheduleValidation: "Selecciona una fecha valida.",
    scheduleSuccess: "Newsletter programada correctamente.",
    scheduleError: "No se pudo programar la newsletter.",
    deliveriesError: "No se pudieron cargar deliveries.",
    deleteSuccess: "Newsletter eliminada correctamente.",
    deleteError: "No se pudo eliminar la newsletter.",
  },
  nav: {
    streamerProfile: "Perfil",
    streamerProfileDescription: "Configura tus conexiones sociales y preferencias",
    createClips: "Crear clips",
    createClipsDescription: "Crea y segmenta tus VODs para crear clips",
    clipsShort: "Clips",
    agenda: "Agenda",
    agendaDescription: "Consulta tus publicaciones programadas y publicadas",
    analysis: "Análisis",
    analysisDescription: "Próximamente: rendimiento de tus clips",
    comingSoonTag: "Próximamente",
    unlimitedTag: "Unlimited",
    mobileBottomNav: "Navegación principal",
    toggleSidebar: "Abrir o cerrar menú",
    studio: "Studio",
    studioDescription: "Convierte videos completos de Drive para crear clips",
    vodClips: "Clips de VOD",
    vodClipsDescription: "Gestiona tus clips y revisiones",
    dashboard: "Dashboard",
    results: "Resultados",
    schedulePost: "Programar clips",
    billing: "Planes",
    affiliateProgram: "Afiliados",
    twitchPostAdmin: "Twitch Post Admin",
    cliprPurchases: "Clipr Purchases",
    subscriptionPlansAdmin: "Planes de suscripción",
    newsletters: "Emails",
    manageUsers: "Administrar usuarios",
    userProfile: "Perfil de usuario",
    usersAdmin: "Administrar usuarios",
    uploadContent: "Subir contenido",
    suggestions: "Sugerencias",
    help: "Ayuda",
    helpBack: "Volver",
    tutorials: "Tutoriales",
    logout: "Cerrar sesión",
    admin: "Admin",
  },
  suggestions: {
    eyebrow: "TU OPINIÓN",
    title: "Comparte una sugerencia",
    intro: "Cuéntanos qué mejorarías en Clipr.",
    category: "Tipo de sugerencia",
    categoryPlaceholder: "Selecciona una opción",
    idea: "Nueva idea",
    improvement: "Mejora",
    problem: "Problema",
    other: "Otro",
    subject: "Asunto",
    subjectPlaceholder: "Resume tu sugerencia",
    description: "Descripción",
    descriptionPlaceholder: "Describe tu idea o problema con el mayor detalle posible",
    successNotice: "Sugerencia enviada. Gracias por compartir tu opinión.",
    authRequired: "Debes iniciar sesión para enviar una sugerencia.",
    submit: "Enviar sugerencia",
    submitting: "Enviando...",
  },
  agenda: {
    title: "Agenda",
    subtitle: "Tus publicaciones programadas y publicadas",
    loginRequired: "Debes iniciar sesión para ver tu agenda.",
    view: "Vista de agenda",
    agendaView: "Agenda",
    monthView: "Mes",
    scheduled: "Programado",
    published: "Publicado",
    more: "más",
    noEvents: "No hay clips programados en este período.",
    noEventsForDay: "No hay clips programados este día.",
  },
  analysis: {
    status: "BAJO CONSTRUCCIÓN",
    title: "Análisis en camino",
    description: "Muy pronto podrás entender el rendimiento de tus clips y descubrir qué contenido funciona mejor.",
  },
  welcome: {
    eyebrow: "EMPIEZA AQUÍ",
    title: "Bienvenido a Clipr",
    subtitle: "Conoce el flujo para convertir tus streams en clips listos para publicar.",
    comingSoon: "PRÓXIMAMENTE",
    featuredLabel: "VIDEO DE BIENVENIDA",
    featuredTitle: "Bienvenido a Clipr",
    featuredDescription: "Un recorrido rápido por todo lo que puedes hacer con Clipr.",
    videoCreateTitle: "Crea tu primer clip",
    videoCreateDescription: "Procesa un stream y encuentra los mejores momentos.",
    videoEditTitle: "Edita tus clips",
    videoEditDescription: "Ajusta el corte final antes de renderizar.",
    videoScheduleTitle: "Programa tus publicaciones",
    videoScheduleDescription: "Deja tus clips listos para publicar.",
    videoConnectionsTitle: "Conecta tus redes",
    videoConnectionsDescription: "Vincula tus plataformas para publicar desde Clipr.",
  },
  dashboard: {
    title: "Estadísticas",
    subtitle: "Conecta tus redes sociales y observa tu crecimiento.",
    loading: "Cargando...",
    reload: "Recargar",
    data: "Datos del dashboard",
    totalImpressions: "Impresiones totales",
    totalImpressionsNoData: "No hay datos de impresiones totales para mostrar.",
    impressionsTimelineTitle: "Evolucion por fecha",
    impressionsTimelineNoDataByDate:
      "No se encontraron datos por fecha en la respuesta para construir la grafica comparativa.",
    viewFullDataJson: "Ver datos completos (JSON)",
    timelineTooltipDatePrefix: "Fecha:",
    timelineTooltipImpressionsSuffix: "impresiones",
    timelineNoData: "Sin datos disponibles",
    facebookConfigTooltip: "Configurar Facebook Page ID",
    facebookModalTitle: "Configuracion de Facebook",
    facebookPageIdTitle: "Estadisticas de tu pagina",
    facebookPageIdHint: "Selecciona tu página de Facebook para ver métricas correctamente.",
    facebookPageIdLabel: "Página de Facebook",
    facebookPageIdPlaceholder: "Selecciona una página",
    facebookPageConnectFirst: "Conecta Facebook primero",
    loadingFacebookPages: "Cargando páginas de Facebook...",
    facebookPagesLoadError: "No se pudieron cargar tus páginas de Facebook.",
    facebookPagesEmpty: "No hay páginas de Facebook disponibles para esta cuenta.",
    facebookPageUnknownName: "Página guardada",
    facebookPageIdSaving: "Guardando...",
    facebookPageIdSave: "Guardar",
    facebookPageIdUpdate: "Actualizar",
    facebookPageIdLoginRequired: "Debes iniciar sesion para actualizar el Page ID.",
    emptyNoConnectionsTitle: "Conecta tus redes sociales",
    emptyNoConnectionsBody:
      "Aun no tienes redes sociales conectadas. Conectalas para empezar a ver metricas y subir contenido desde Clipr.",
    emptyNoConnectionsCta: "Conecta tus redes",
    firstVideoCta: "Descargar primer video",
    emptyNoClipsTitle: "Crea tu primer clip",
    emptyNoClipsBody:
      "Aun no tienes clips creados. Empieza con tu primer clip para comenzar a ver actividad en tu dashboard.",
    videoImpressionsSyncButton: "Actualizar impresiones por video",
    videoImpressionsSyncModalTitle: "Actualizar impresiones por video",
    videoImpressionsSyncLimitLabel: "Limite de clips",
    videoImpressionsSyncStartDateLabel: "Fecha inicial",
    videoImpressionsSyncEndDateLabel: "Fecha final",
    videoImpressionsSyncHint:
      "Se actualizaran hasta {limit} clips publicados entre {startDate} y {endDate}, empezando por los mas recientes.",
    videoImpressionsSyncSubmit: "Actualizar impresiones",
    videoImpressionsSyncSubmitting: "Actualizando...",
    videoImpressionsSyncSummary:
      "Sincronizacion completada. Se actualizaron {updated} de {processed} clips; {failed} quedaron sin metricas y {skipped} se omitieron.",
    videoImpressionsSyncLimitError: "El limite debe ser un entero entre 1 y 100.",
    videoImpressionsSyncDateError: "Selecciona un rango valido (fecha inicial menor o igual a fecha final).",
    videoImpressionsSyncLoginRequired: "Debes iniciar sesion para actualizar impresiones por video.",
    videoImpressionsSyncGenericError: "No se pudieron actualizar las impresiones por video.",
    noSocialConnectionsMessage:
      "Aun no tienes redes sociales conectadas. Conecta al menos una red desde tu perfil para ver estas metricas.",
  },
  login: {
    forgotTitle: "Restablecer contraseña",
    forgotDescription:
      "Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.",
    emailLabel: "Correo electrónico",
    placeholderEmail: "Introduce tu correo",
    resetSending: "Enviando enlace...",
    resetSendLink: "Enviar enlace",
    backToLogin: "Volver al inicio de sesión",
    signupTitle: "Crea tu cuenta",
    signupDescription:
      "Introduce tus datos para activar tu cuenta y empezar a transformar tu contenido con Clipr.",
    fullNameLabel: "Nombre completo",
    namePlaceholder: "Ej. Juan Pérez",
    passwordLabel: "Contraseña",
    confirmPasswordLabel: "Confirmar contraseña",
    placeholderCreatePassword: "Crea una contraseña",
    placeholderRepeatPassword: "Repite tu contraseña",
    reqMinChars: "Mínimo 8 caracteres",
    reqUppercase: "Al menos una mayúscula",
    reqNumber: "Al menos un número",
    reqSpecial: "Al menos un carácter especial",
    creatingAccount: "Creando cuenta...",
    createAccount: "Crear cuenta",
    orSeparator: "O",
    signUpWithGoogle: "Registrarse con Google",
    alreadyHaveAccount: "¿Ya tienes cuenta?",
    signInLink: "Iniciar sesión",
    welcomeTitle: "¡Bienvenido de nuevo!",
    welcomeDescription:
      "Inicia sesión y deja que la IA transforme tu material en vídeos cortos para todas tus plataformas.",
    forgotPasswordLink: "¿Olvidaste tu contraseña?",
    placeholderPassword: "Introduce tu contraseña",
    signingIn: "Iniciando sesión...",
    signInButton: "Iniciar sesión",
    continueWithGoogle: "Continuar con Google",
    dontHaveAccount: "¿No tienes cuenta?",
    signUpLink: "Registrarse",
    promoTitle: "Transforma tu contenido con creación de vídeo asistida por IA.",
    testimonialQuote:
      "Clipr ha revolucionado nuestro flujo de contenido. Subimos el material una vez y la IA crea y publica vídeos cortos cada día en todas las plataformas. Es como tener un equipo de producción 24/7.",
    testimonialName: "Michael Carter",
    testimonialRole: "Creador de contenido en DevCore",
    teamsTitle: "ÚNETE A 1K EQUIPOS",
    errorLoginGeneric: "Ha ocurrido un error al iniciar sesión",
    errorGoogleLogin: "Ha ocurrido un error al iniciar sesión con Google",
    signupAllFieldsRequired: "Todos los campos son obligatorios.",
    signupPasswordRequirements: "La contraseña no cumple los requisitos de seguridad.",
    signupPasswordsMismatch: "Las contraseñas no coinciden.",
    signupErrorGeneric: "Ha ocurrido un error al crear la cuenta.",
    signupSuccessSimple: "Cuenta creada. Ya puedes iniciar sesión.",
    resetEmailRequired: "Introduce tu correo electrónico.",
    resetEmailSent: "Revisa tu correo para el enlace de restablecimiento.",
    resetErrorGeneric: "Ha ocurrido un error al enviar el enlace.",
    oauthErrorGeneric: "Error de autenticación. Inténtalo de nuevo.",
  },
  updatePassword: {
    title: "Crea una nueva contraseña",
    description: "Define una nueva contraseña para mantener segura tu cuenta de Clipr.",
    newPasswordLabel: "Nueva contraseña",
    newPasswordPlaceholder: "Introduce tu nueva contraseña",
    updating: "Actualizando...",
    submit: "Actualizar contraseña",
    success: "Contraseña actualizada correctamente. Redirigiendo al inicio de sesión...",
    errorGeneric: "Ha ocurrido un error al actualizar la contraseña.",
  },
  notFound: {
    title: "Esta pagina no existe",
    subtitle: "Es posible que el enlace este desactualizado o que la pagina se haya movido. Vuelve a Crear clips para seguir trabajando.",
    backToCreateClips: "Volver a Crear clips",
  },
  affiliateProgram: {
    eyebrow: "Clipr Partners",
    title: "Programa de Afiliados",
    subtitle: "Recomienda Clipr y gana 30% de cada pago de suscripción.",
    backToProfile: "Volver al perfil",
    loading: "Cargando programa...",
    joinTitle: "Convierte tus recomendaciones en ingresos",
    joinDescription: "Recibe 30% de cada pago durante toda la vida de las suscripciones que refieras. Tu enlace queda listo al instante.",
    benefitLifetime: "30% recurrente de por vida",
    benefitHold: "Comisiones pagables después de 30 días",
    benefitPayout: "Pagos manuales por SPEI o PayPal",
    benefitPremiumBonus: "Con tu primer pago de $25 USD recibes una suscripción anual de Clipr Premium sin costo",
    acceptPrefix: "Acepto los",
    termsLink: "términos del programa",
    enrolling: "Generando...",
    generateLink: "Generar mi enlace",
    yourLink: "Tu enlace personal",
    shareLink: "Compartir enlace",
    copyLink: "Copiar enlace",
    customizeUrl: "Personalizar URL",
    hideCustomizeUrl: "Ocultar",
    codePlaceholder: "tu-codigo",
    customizeCode: "Personaliza tu código",
    codeHint: "Usa letras, números y guiones. Tus códigos anteriores seguirán funcionando y quedarán reservados para ti.",
    saveCode: "Guardar",
    savingCode: "Guardando...",
    codeSaved: "Guardado",
    codeTaken: "Ese código ya está reservado.",
    lastClick: "Tu enlace se vincula 90 días al usuario. Si se registra en ese periodo, queda atribuido a ti.",
    copied: "Copiado",
    copy: "Copiar",
    activityTitle: "Actividad",
    activitySubtitle: "Tráfico y conversiones de tu enlace.",
    clicks: "Clicks",
    signups: "Registros",
    payingReferrals: "Referidos de pago",
    payingReferralsShort: "De pago",
    earningsTitle: "Ganancias",
    earningsSubtitle: "Comisiones por estado de pago.",
    pending: "Pendiente",
    payable: "Pagable",
    paid: "Pagado",
    requestPayout: "Solicitar pago",
    payoutReady: "Listo para solicitar",
    payoutNotReady: "Aún no disponible",
    payoutHint: "Disponible desde $25 USD. Necesitas WhatsApp para enviar la solicitud.",
    preparingWhatsApp: "Preparando...",
    openWhatsApp: "Solicitar por WhatsApp",
    payoutHistoryTitle: "Historial de pagos",
    payoutHistorySubtitle: "Consulta el estado de tus solicitudes de pago.",
    requestedAt: "Solicitado",
    amount: "Monto",
    status: "Estado",
    paidAt: "Pagado",
    noPayouts: "Aún no has solicitado pagos.",
    payoutRequested: "Solicitado",
    payoutPaid: "Pagado",
    payoutRejected: "Rechazado",
    monthlyTitle: "Resumen mensual",
    monthlySubtitle: "Clicks, registros y comisiones por mes.",
    month: "Mes",
    noActivity: "Aún no hay actividad para mostrar.",
    authRequired: "Debes iniciar sesión.",
    profileTitle: "Programa de Afiliados",
    profileDescription: "Obtén tu enlace y gana 30% recurrente por cada suscripción referida.",
    faqOpen: "Dudas comunes",
    faqClose: "Cerrar",
    faqEyebrow: "Ayuda",
    faqTitle: "Dudas comunes",
    faq: {
      q1: "¿Cuánto gano?",
      a1: "Ganas el 30% de cada pago que haga la persona que invites.",
      q2: "¿Solo me pagan una vez?",
      a2: "No. Cada vez que tu referido pague su plan, tú recibes tu parte. Si sigue pagando mes con mes, tú sigues ganando.",
      q3: "¿Cuándo puedo retirar mi dinero?",
      a3: "Primero esperas 30 días. Después ese dinero ya aparece como pagable y puedes pedir que te lo paguen.",
      q4: "¿Cuánto necesito para pedir un pago?",
      a4: "Necesitas tener al menos $25 USD pagables.",
      q5: "¿Cómo me pagan?",
      a5: "Cuando llegues a $25, toca el botón de WhatsApp en tu panel y envía tu solicitud. Te pagamos por SPEI o PayPal.",
      q6: "¿Cómo uso mi enlace?",
      a6: "Compártelo con quien quieras. Si alguien entra con tu enlace y se registra, queda ligado a ti por 90 días desde su última visita con tu enlace.",
      q7: "¿Qué es pendiente, pagable y pagado?",
      a7: "Pendiente: todavía en espera. Pagable: ya puedes pedir tu pago. Pagado: ya te lo enviamos.",
      q8: "¿Puedo usar mi propio enlace?",
      a8: "No. Solo ganas cuando invitas a otras personas.",
      q9: "¿Quién sí cuenta como referido?",
      a9: "Tiene que ser alguien nuevo que se registre con tu enlace y pague un plan premium. Si ya tenía cuenta o no paga el plan, no ganas comisión.",
    },
  },
  userProfile: {
    streamerProfileTitle: "Perfil de usuario",
    streamerProfileDescription:
      "Configura el idioma y conecta tus redes sociales.",
    clipSubtitlesTitle: "Subtítulos",
    clipSubtitlesDescription: "Subtítulos automáticos en clips nuevos.",
    clipSubtitlesSwitchAria: "Activar subtítulos en clips",
    subtitleStyleTitle: "Estilo",
    subtitleStyleEdit: "Editar",
    subtitleStyleModalTitle: "Estilo de subtítulos",
    subtitleStyleModalHint: "Se aplicará a clips nuevos.",
    subtitleStyleFont: "Fuente",
    subtitleStyleEffect: "Tipo de resaltado",
    subtitleStyleEffectTextColor: "Color en texto",
    subtitleStyleEffectBackground: "Resaltado",
    subtitleStyleColor: "Color",
    subtitleStylePreviewSuffix: "es el mejor",
    minimalProfileSubtitle:
      "Elige el idioma de la interfaz y conecta tus cuentas para publicar.",
    socialSectionTitle: "Redes sociales",
    socialSectionDesc: "Conecta tus cuentas para publicar y sincronizar contenido.",
    freeSectionTitle: "Preferencias",
    freeSectionSubtitle:
      "Puedes cambiar el nombre visible en tus clips, el idioma de la interfaz y la zona horaria.",
    proSectionTitle: "Funciones PRO",
    proSectionSubtitle:
      "Conecta tus redes sociales para publicar y sincronizar, y personaliza el logo final de tus clips.",
    proBadgeAriaLabel: "Plan PRO",
    savePreferences: "Guardar",
    notConnected: "No conectado",
    connected: "Conectado",
    manage: "Administrar",
    connect: "Conectar",
    returnToProfile: "Volver al perfil",
    connectionPageOpened: "Se abrió la página de conexión",
    facebookPageIdRegion: "Configuración de Facebook Page ID",
    facebookPageIdTitle: "Estadísticas de tu página",
    facebookPageIdHint:
      "Busca y selecciona tu página de Facebook para ver métricas correctamente.",
    facebookPageIdLabel: "Página de Facebook",
    facebookPageSearchPlaceholder: "Buscar por nombre o ID",
    refreshFacebookPages: "Actualizar",
    loading: "Cargando...",
    loadingFacebookPages: "Cargando páginas de Facebook...",
    facebookPagesLoadError: "No se pudieron cargar tus páginas de Facebook.",
    facebookPagesEmpty: "No hay páginas de Facebook disponibles para esta cuenta.",
    facebookPagesNoResults: "No se encontraron páginas con esa búsqueda.",
    facebookPageUnknownName: "Página guardada",
    facebookPageIdPlaceholder: "Elige página",
    facebookPageConnectFirst: "Conecta Facebook primero",
    facebookPageUnifiedPlaceholder: "Conecta y elige página",
    saving: "Guardando…",
    savePageId: "Guardar",
    updatePageId: "Actualizar",
    facebookPageIdSaved: "Facebook Page ID actualizado correctamente",
    facebookPageIdRequired: "El ID de la página es obligatorio",
    languageTitle: "Idioma de la interfaz",
    preferencesTitle: "Preferencias",
    languageHint: "Elige el idioma que quieres usar en toda la plataforma.",
    languageSaved: "Idioma actualizado correctamente",
    languageSaveError: "Error al guardar el idioma",
    timezoneTitle: "Zona horaria de programacion",
    timezoneHint: "Define la zona horaria usada para programar clips.",
    timezoneLabel: "Zona horaria",
    selectTimezone: "Selecciona zona horaria",
    timezoneSaved: "Zona horaria actualizada correctamente",
    timezoneSaveError: "Error al guardar la zona horaria",
    timezoneRequired: "Selecciona una zona horaria",
    personalizationTitle: "Personalización",
    personalizationHint:
      "Ajusta la marca que aparece en el cierre de tus clips renderizados.",
    customLogoTitle: "Logo final de tus clips",
    customLogoHint:
      "Sube un PNG con fondo transparente para la pantalla final. Si no subes uno, se usará el logo de Clipr por defecto. También puedes desactivar por completo la pantalla final con el interruptor de abajo.",
    customLogoLabel: "Archivo PNG",
    customLogoBrowseButton: "Seleccionar archivo",
    customLogoFileHint:
      "PNG sin fondo · máx. 2 MB · máx. 1024×1024 px. Elige un archivo.",
    customLogoSaved: "Logo actualizado correctamente",
    customLogoSaveError: "Error al guardar el logo",
    customLogoInvalidFile: "Solo se permiten archivos PNG (.png).",
    customLogoFileTooLarge: "El archivo supera el tamaño máximo de 2 MB.",
    customLogoDimensionsTooLarge: "La imagen supera el tamaño máximo de 1024×1024 px.",
    customLogoImageReadError:
      "No se pudo leer la imagen. Comprueba que sea un PNG válido.",
    customLogoPreviewAlt: "Vista previa del logo",
    adminBrandingTitle: "Pantalla final y watermark",
    adminBrandingHint: "Personaliza los elementos que aparecen en tus clips.",
    adminOnlyBadge: "SOLO ADMIN",
    adminWatermarkTitle: "Watermark personalizada",
    adminWatermarkHint:
      "Esta imagen reemplaza la watermark por defecto de Clipr cuando tu watermark esté activa.",
    adminWatermarkPreviewLabel: "Vista previa",
    adminWatermarkPreviewAlt: "Vista previa de la watermark",
    adminWatermarkEmptyState:
      "Sin watermark personalizada. Se usará la watermark por defecto de Clipr.",
    adminWatermarkFileLabel: "Archivo PNG",
    adminWatermarkBrowseButton: "Seleccionar archivo",
    adminWatermarkFileHint: "PNG · máx. 2 MB.",
    adminWatermarkInvalidFile: "Solo se permiten archivos PNG (.png).",
    adminWatermarkFileTooLarge: "El archivo supera el tamaño máximo de 2 MB.",
    adminWatermarkSaved: "Watermark personalizada actualizada correctamente",
    adminWatermarkSaveError: "Error al guardar la watermark personalizada",
    adminWatermarkSessionError:
      "Error: sesión no encontrada. Por favor inicia sesión de nuevo.",
    activeVideoEndcardLabel: "Mostrar pantalla final (logo y nombre) en los clips",
    activeVideoEndcardSaved: "Preferencia de pantalla final actualizada",
    activeVideoEndcardSaveError: "Error al guardar la pantalla final",
    activeVideoEndcardSwitchAria: "Activar o desactivar la pantalla final en los clips",
    customLogoSectionSavedBoth: "Pantalla final y logo actualizados correctamente",
    endCardTab: "Pantalla final",
    displayNameTitle: "Nombre de usuario",
    displayNameHint:
      "Es el nombre que se muestra en la pantalla final de tus clips y en tu perfil.",
    displayNameLabel: "Nombre visible",
    displayNameSaved: "Nombre actualizado correctamente",
    displayNameSaveError: "Error al guardar el nombre",
    displayNameRequired: "Introduce un nombre.",
    sessionError: "Error: Sesión no encontrada. Por favor, inicia sesión de nuevo.",
    fontSettings: {
      title: "Configuración de fuente",
      fontName: "Nombre de la fuente",
      fontColor: "Color de la fuente",
      fontWeight: "Peso de la fuente",
      hexColorHint: "Selecciona o introduce un código hex",
      weightThin: "Fino",
      weightExtraLight: "Extra ligero",
      weightLight: "Ligero",
      weightRegular: "Regular",
      weightMedium: "Medio",
      weightSemiBold: "Semi negrita",
      weightBold: "Negrita",
      weightExtraBold: "Extra negrita",
      weightBlack: "Negro",
      hexColorError: "Introduce un color hex válido (ej., #000000)",
      saveSuccess: "¡Configuración guardada correctamente!",
      saveError: "Error al guardar la configuración",
    },
  },
};
